import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import { useNavigate } from "react-router-dom";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import InputLabel from "@mui/material/InputLabel";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import VisibilityIcon from "@mui/icons-material/Visibility";
import LoopIcon from "@mui/icons-material/Loop";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import CloseIcon from "@mui/icons-material/Close";
import Tooltip from "@mui/material/Tooltip";
import ChatIcon from "@mui/icons-material/Chat";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { competencyBlockIconSrc } from "../utils/competencyBlockIcon";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import RepeatIcon from "@mui/icons-material/Repeat";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {
  editexercise,
  applyPlanningExerciseBatch,
  exerciseswap,
  sessiondeleteex,
  deleteTrainingExerciseSequence,
  sessionexlist,
  getTrainingSessionTemplates,
  applyTrainingSessionTemplate,
  listSessionSubgroups,
  createSessionSubgroup,
  updateSessionSubgroup,
  deleteSessionSubgroup,
  swapTrainingBlockExercises,
  syncBlockExercise,
  addexercise,
  updateexercise,
  tablelist,
  exdetails,
  complist,
} from "./funtionsBD/Mainservice";
import { ip_back } from "../config";
import { ExerciseCard } from "./ExerciseCard";
import { KingOfTableSettings } from "./KingOfTableSettings";
import { ExchangeExerciseDialog } from "./planning/ExchangeExerciseDialog";
import { SyncBlockExerciseDialog } from "./planning/SyncBlockExerciseDialog";
import { OffTableCoachToolsEditor } from "./planning/OffTableCoachToolsEditor";
import "../pages/Exerciseadd/Exercise.css";
import "./planning/EditExerciseDialog.css";
import { usePermissions } from "../context/Permissioncontext";
import { useBrand } from "../context/BrandContext";
import { usePlanningAccess } from "../hooks/usePlanningAccess";
import { userCanManagePastTrainingSessions } from "../utils/planningAccess";
import axios from "axios";
import { initializeSocket } from "../socket";
import {
  pickCoachControlTargetIndex,
  shouldUseContinueControlLabel,
  getExerciseStateLabel,
  TE_STATE_CANCELLED,
  TE_STATE_FINALIZED,
  TE_STATE_STARTED,
} from "../utils/coachExerciseNavigation";
import {
  isKotExercise,
  isSoloCapableSequenceExercise,
  isSubtypeFreeExerciseType,
  isOffTableExercise,
  isCompetencyBlockExerciseType,
} from "../utils/teExecutionType";
import { isPersonalizedTrainingSlot } from "../utils/personalizedTrainingSlot";
import { coachToolsFromExercise } from "../utils/teCoachTools";
import {
  playEndExerciseSound,
  playSequenceAlarmFromServer,
  sequenceRemainingFromPayload,
} from "../utils/exerciseTimerSounds";
import { PlanningSubgroupBoard } from "./planning/PlanningSubgroupBoard";
import { PlanningExerciseDetailsDialog } from "./planning/PlanningExerciseDetailsDialog";
import { PlanningPingfloVoice } from "./planning/PlanningPingfloVoice";
import { SplitSubgroupDialog } from "./planning/SplitSubgroupDialog";
import { SelectSessionTemplateDialog } from "./planning/SelectSessionTemplateDialog";
import { TemplateApplyWizardDialog } from "./planning/TemplateApplyWizardDialog";
import { useTourDemoActive } from "../tour/useTourDemoActive";
import {
  blockTypeHeadline,
  buildPlanningLanes,
  canSwapPlanningBlockExercises,
  exerciseLabel,
  isPlaceholderBlock,
  isTypeOnlyBlock,
  isPlanningBlockLocked,
  mapListWithSyncedDuration,
  persistPlanningFocus,
  persistPlanningTsgId,
  PLANNING_REFRESH_EVENT,
  readPlanningTsgId,
  requestPlanningRefresh,
  swapTrainingBlockExercisesInList,
  wallClockMinutes,
} from "../utils/planningSubgroups";
import {
  parseDurationMinutes,
  formatDurationLabel,
  formatMinutesForStorage,
  distributeMinutesAcrossSequences,
} from "../utils/trainingDuration";
import DurationMinutesSecondsInput from "./DurationMinutesSecondsInput";
import { formatTrainingSessionHash } from "../utils/formatTrainingSessionLabel";
import { addExerciseNavigation } from "../utils/addExerciseNavigation";
import { currentAppLanguage } from "../utils/appLanguages";
import { localizedExerciseName, localizedTypeName } from "../utils/localizedCatalogFields";

/** JSON snapshot of exercise + sequence fields for planning dirty detection (durations + A/B roles). */

/** Group id from Home slider (`grpinf`) or from the session row (e.g. after duplicate). */
function resolveSessionGroupId(selectedSession, selectedgrp) {
  return (
    selectedgrp?.groupDetails?.gr_id ||
    selectedSession?.gr_id ||
    selectedSession?._groupId ||
    selectedSession?.groupDetails?.gr_id ||
    null
  );
}

function hasSessionAndGroup(selectedSession, selectedgrp) {
  return Boolean(selectedSession?.ts_id && resolveSessionGroupId(selectedSession, selectedgrp));
}

function buildPlanningDurationSnapshot(list) {
  return JSON.stringify(
    (list || []).map((ex) => ({
      te_id: String(ex.te_id),
      te_duration: String(ex.te_duration ?? "").trim(),
      sequences: [...(ex.sequences || [])]
        .slice()
        .sort((a, b) => (a.sequence_order ?? 9999) - (b.sequence_order ?? 9999))
        .map((s) => ({
          tes_id: String(s.tes_id),
          sequence_duration: String(s.sequence_duration ?? "").trim(),
          player_a_role: String(s.player_a_role ?? "active"),
          player_b_role: String(s.player_b_role ?? "sparring"),
        })),
    }))
  );
}

/**
 * Minutes for one exercise — matches backend editTrainingExercise / calculateExerciseDuration:
 * sum sequence durations when sequences exist, otherwise te_duration.
 */
function getExerciseDurationMinutesForPlanning(ex) {
  const seqs = ex?.sequences;
  if (Array.isArray(seqs) && seqs.length > 0) {
    return seqs.reduce(
      (sum, seq) => sum + parseDurationMinutes(seq?.sequence_duration),
      0
    );
  }
  return parseDurationMinutes(ex?.te_duration);
}

function distributeExerciseMinutesAcrossSequences(totalMinutesStr, sequences) {
  return distributeMinutesAcrossSequences(totalMinutesStr, sequences, {
    asString: true,
  });
}

/** English canonical name for competency-block exercise type (avoid showing generic label on cards). */
const BLOCKS_OF_COMPETENCY_TYPE_EN = "Blocks of competency";
const OFF_TABLE_TYPE_EN = "Off-table exercises";

const isOffTableExerciseType = (typeRow) =>
  (typeRow?.type_name_en || "").trim() === OFF_TABLE_TYPE_EN;

const isSubtypeFreeType = (typeRow) =>
  isOffTableExerciseType(typeRow) || isSubtypeFreeExerciseType(typeRow);

function nestedId(value, keys) {
  if (value == null || value === "") return null;
  if (typeof value === "object") {
    for (const key of keys) {
      if (value[key]) return value[key];
    }
    return null;
  }
  return value;
}

function trainingBlockKindId(exercise) {
  if (!exercise) return null;
  const isCb = isCompetencyBlockExerciseType(
    exercise.type_ex || exercise.tbl_type_ex
  );
  if (isCb) {
    // Never fall back to skill subtype ids — editTrainingExercise rejects those as CBs.
    return (
      nestedId(exercise.ex_sub_type_id, ["cb_id"]) ||
      (typeof exercise.ex_sub_type_id === "string" ? exercise.ex_sub_type_id : null) ||
      exercise.competency_block?.cb_id ||
      exercise.blocks_compentency?.cb_id ||
      exercise.sequences?.[0]?.competency_block?.cb_id ||
      (typeof exercise.sequences?.[0]?.sub_type_id === "string"
        ? exercise.sequences[0].sub_type_id
        : nestedId(exercise.sequences?.[0]?.sub_type_id, ["cb_id"])) ||
      null
    );
  }
  return (
    nestedId(exercise.ex_sub_type_id, ["sub_type_id", "cb_id"]) ||
    exercise.sub_type_ex?.sub_type_id ||
    exercise.sequences?.[0]?.sub_type_id ||
    null
  );
}

function localizedSubTypeName(st, base) {
  if (!st) return "";
  return (
    (st[`sub_type_name_${base}`] || "").trim() ||
    (st.sub_type_name_en || "").trim() ||
    (st.sub_type_name_fr || "").trim() ||
    (st.sub_type_name_de || "").trim() ||
    (st.sub_type_name_es || "").trim() ||
    ""
  );
}

function localizedCbName(cb, base) {
  if (!cb || typeof cb !== "object") return "";
  return (
    (cb[`cb_name_${base}`] || "").trim() ||
    (cb.cb_name_en || "").trim() ||
    (cb.cb_name_fr || "").trim() ||
    (cb.cb_name_de || "").trim() ||
    (cb.cb_name_es || "").trim() ||
    ""
  );
}

/**
 * Planning card badge: for CB exercises, prefer tbl_exe_cb → tbl_blocks_compentency (`competency_block`),
 * then session-level block, skill sub-type, then first sequence block/skill.
 */
function getPlanningExerciseKindLabel(exercise, lng) {
  const base = (lng || "en").split("-")[0];
  const isBlocksOfCompetency =
    exercise?.type_ex?.type_name_en === BLOCKS_OF_COMPETENCY_TYPE_EN;

  if (isBlocksOfCompetency) {
    const fromExeCb = localizedCbName(exercise.competency_block, base);
    if (fromExeCb) return fromExeCb;
    const fromTe = localizedCbName(exercise.ex_sub_type_id, base);
    if (fromTe) return fromTe;
    const skill = localizedSubTypeName(exercise.sub_type_ex, base);
    if (skill) return skill;
    const first = exercise.sequences?.[0];
    const fromSeqCb = localizedCbName(first?.competency_block, base);
    if (fromSeqCb) return fromSeqCb;
    const fromSeqSt = localizedSubTypeName(first?.sub_type_ex, base);
    if (fromSeqSt) return fromSeqSt;
    return "";
  }

  return localizedSubTypeName(exercise.sub_type_ex, base);
}

/** Normalize subtype / competency-block label for cross-type matching (e.g. Coup droit). */
function normalizeSkillLabel(s) {
  if (!s) return "";
  return String(s)
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ")
    .trim();
}

function addLocalizedFieldNorms(obj, fieldStem, langs, acc) {
  if (!obj || typeof obj !== "object") return;
  for (const lng of langs) {
    const key = `${fieldStem}${lng}`;
    const raw = (obj[key] || "").trim();
    if (raw) acc.add(normalizeSkillLabel(raw));
  }
}

/** Normalized labels from an exercise row (subtype and, for BC, block names). */
function collectExerciseSkillNorms(exercise) {
  const norms = new Set();
  const langs = ["en", "fr", "de", "es", "nl", "pt"];
  const isBC = exercise?.type_ex?.type_name_en === BLOCKS_OF_COMPETENCY_TYPE_EN;
  if (isBC) {
    addLocalizedFieldNorms(exercise.competency_block, "cb_name_", langs, norms);
    addLocalizedFieldNorms(exercise.ex_sub_type_id, "cb_name_", langs, norms);
    addLocalizedFieldNorms(exercise.sub_type_ex, "sub_type_name_", langs, norms);
    const first = exercise.sequences?.[0];
    if (first) {
      addLocalizedFieldNorms(first.competency_block, "cb_name_", langs, norms);
      addLocalizedFieldNorms(first.sub_type_ex, "sub_type_name_", langs, norms);
    }
  } else {
    addLocalizedFieldNorms(exercise.sub_type_ex, "sub_type_name_", langs, norms);
  }
  return norms;
}

function exerciseMatchesSkillNorm(exercise, selectedNorm) {
  if (!selectedNorm) return false;
  for (const n of collectExerciseSkillNorms(exercise)) {
    if (n === selectedNorm) return true;
  }
  return false;
}

export const Exercises = forwardRef(function Exercises(
  {
    setSelectedExercise,
    selectedExercise,
    selectedSession,
    handleFilterClick,
    selectedgrp,
    onSessionMetaUpdate,
    onPlanningDurationDirtyChange,
    onPlanningTotalDurationChange,
    /** Planning: notify parent for Start vs Continue on session card */
    onCoachExerciseControlContext,
    /** Planning: running KoT exercise for session-card Start new round button */
    onKotStartRoundContext,
  },
  ref
) {
  const [list, setlist] = useState([]);
  /** Last saved planning durations (from server); used to detect unsaved edits */
  const [planningDurationBaseline, setPlanningDurationBaseline] = useState(null);
  const [sessionExerciseListLoading, setSessionExerciseListLoading] =
    useState(false);
  const sessionExerciseListLoadCountRef = useRef(0);
  const [showoption, setshowoption] = useState(false);
  const [open, setopen] = useState(false);
  const [contnt, setcontnt] = useState(false);
  const [success, setsuccess] = useState();
  const [error, seterror] = useState();
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [templateDialogOpen, setTemplateDialogOpen] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [loadingTemplate, setLoadingTemplate] = useState(false);
  const [recommendDialogOpen, setRecommendDialogOpen] = useState(false);
  const [recommendedExercises, setRecommendedExercises] = useState([]);
  const [loadingRecommend, setLoadingRecommend] = useState(false);
  const [selectedRecommendExercise, setSelectedRecommendExercise] = useState(null);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [editingExercise, setEditingExercise] = useState(null);
  const [exchangeDialogOpen, setExchangeDialogOpen] = useState(false);
  const [exchangingExercise, setExchangingExercise] = useState(false);
  const [aiRecommendChoiceDialogOpen, setAiRecommendChoiceDialogOpen] = useState(false);
  const [sessionPlanDialogOpen, setSessionPlanDialogOpen] = useState(false);
  const [generatedSessionPlan, setGeneratedSessionPlan] = useState(null);
  const [loadingSessionPlan, setLoadingSessionPlan] = useState(false);
  const [structuredSessionDialogOpen, setStructuredSessionDialogOpen] = useState(false);
  const [includeStretchingAddon, setIncludeStretchingAddon] = useState(false);
  /** When mode is template: coach's chosen ex_id per slot (itemIndex -> ex_id). Defaults to first recommended per slot. */
  const [sessionPlanSlotSelections, setSessionPlanSlotSelections] = useState({});
  const [templateApplyWizardOpen, setTemplateApplyWizardOpen] = useState(false);
  const [recommendationSessionType, setRecommendationSessionType] = useState("main");
  const [exerciseTypes, setExerciseTypes] = useState([]);
  const [exerciseSubTypes, setExerciseSubTypes] = useState([]);
  const [competencyBlocks, setCompetencyBlocks] = useState([]);
  const [selectedTypeId, setSelectedTypeId] = useState(null);
  const [selectedSubTypeId, setSelectedSubTypeId] = useState(null);
  const [selectedCatalogExercise, setSelectedCatalogExercise] = useState(null);
  const [editDuration, setEditDuration] = useState("");
  const [editCoachTools, setEditCoachTools] = useState({
    chrono: true,
    count: false,
    count_label: "",
  });
  const [editSequences, setEditSequences] = useState([]);
  const [lastValidDuration, setLastValidDuration] = useState("");
  const [exerciseStates, setExerciseStates] = useState({}); // Real-time exercise states map: te_id -> state
  const [exerciseTimers, setExerciseTimers] = useState({}); // Real-time exercise timers map: te_id -> timer (in seconds)
  const [currentSequences, setCurrentSequences] = useState({}); // Real-time current sequence map: te_id -> currentSequence object
  const [sequenceTimers, setSequenceTimers] = useState({}); // Real-time sequence timers map: te_id -> sequenceTimer (in seconds)
  const [draggedSequenceIndex, setDraggedSequenceIndex] = useState(null);
  const [dragOverSequenceIndex, setDragOverSequenceIndex] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [pressHoldTimer, setPressHoldTimer] = useState(null);
  // Exercise drag and drop state for mobile
  const [draggedExerciseId, setDraggedExerciseId] = useState(null);
  const [dragOverExerciseId, setDragOverExerciseId] = useState(null);
  const [isDraggingExercise, setIsDraggingExercise] = useState(false);
  const [exercisePressHoldTimer, setExercisePressHoldTimer] = useState(null);
  const [exerciseDragOccurred, setExerciseDragOccurred] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [exerciseToDelete, setExerciseToDelete] = useState(null);
  const [subgroups, setSubgroups] = useState([]);
  const [selectedTsgId, setSelectedTsgId] = useState(() => readPlanningTsgId());
  const [splitDialogOpen, setSplitDialogOpen] = useState(false);
  const [splitBusy, setSplitBusy] = useState(false);
  const [roomTables, setRoomTables] = useState([]);
  const [templateTargetTsgId, setTemplateTargetTsgId] = useState(null);
  const [detailsExercise, setDetailsExercise] = useState(null);
  const [swapSource, setSwapSource] = useState(null);
  const [swapBusy, setSwapBusy] = useState(false);
  const [quickCbBusy, setQuickCbBusy] = useState(false);
  const [syncBlockSource, setSyncBlockSource] = useState(null);
  const [syncBlockBusy, setSyncBlockBusy] = useState(false);
  const templateTargetTsgIdRef = useRef(null);
  const templateTargetTeIdRef = useRef(null);
  const pendingAddSequenceRef = useRef(false);
  const [exchangeInitialQuery, setExchangeInitialQuery] = useState("");
  const { sessionUser: user, canEditPlanning, viewerPlayerId } =
    usePlanningAccess();
  const canManagePastSessions = userCanManagePastTrainingSessions(user);
  const tourDemo = useTourDemoActive();
  const role = user?.type_user_id;
  const isSessionReadOnly = !canEditPlanning;
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const { themeMode } = useBrand();
  const brandPrimary =
    typeof document !== "undefined"
      ? getComputedStyle(document.documentElement)
          .getPropertyValue("--brand-primary")
          .trim() || "#0877BC"
      : "#0877BC";
  const editDialogThemeClass = themeMode === "light" ? "light-mode" : "dark-mode";
  const isEditDialogMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const currentlng = currentAppLanguage(i18n);
  const { hasPermission } = usePermissions();
  const token = localStorage.getItem("token");
  const socket = initializeSocket(token);

  const orderedForPlanning = useMemo(
    () => [...list].sort((a, b) => (a.te_order ?? 0) - (b.te_order ?? 0)),
    [list]
  );

  const planningLanes = useMemo(
    () => buildPlanningLanes({ subgroups, exercises: list }),
    [subgroups, list]
  );

  const lockedPlanningTeIds = useMemo(() => {
    const ids = new Set();
    for (const ex of list || []) {
      const live = exerciseStates[ex.te_id];
      if (isPlanningBlockLocked(ex, live)) ids.add(String(ex.te_id));
    }
    return ids;
  }, [list, exerciseStates]);

  const planningVisibleList = useMemo(() => {
    const source = !selectedTsgId
      ? list
      : planningLanes.find((l) => String(l.tsg_id) === String(selectedTsgId))?.exercises || list;
    return (source || []).filter(
      (ex) =>
        !isPlaceholderBlock(ex) ||
        isTypeOnlyBlock(ex) ||
        isPersonalizedTrainingSlot(ex)
    );
  }, [list, planningLanes, selectedTsgId]);

  const lngBase = currentlng;

  const selectedSubtypeNorm = useMemo(() => {
    if (!editDialogOpen || !selectedSubTypeId || !exerciseSubTypes?.length) return "";
    const st = exerciseSubTypes.find((s) => s.sub_type_id === selectedSubTypeId);
    if (!st) return "";
    return normalizeSkillLabel(localizedSubTypeName(st, lngBase));
  }, [editDialogOpen, selectedSubTypeId, exerciseSubTypes, lngBase]);

  const sessionExercisesGroupedForSelectedSubtype = useMemo(() => {
    if (!editDialogOpen || !selectedSubtypeNorm || !list?.length) return [];
    const groups = new Map();
    for (const ex of list) {
      if (!exerciseMatchesSkillNorm(ex, selectedSubtypeNorm)) continue;
      const typeLabel =
        localizedTypeName(ex.type_ex, lngBase) || "—";
      const title =
        localizedExerciseName(ex, lngBase) ||
        (ex.ex_name === null ? t("selectex") || "Select exercise" : "");
      const row = {
        te_id: ex.te_id,
        te_order: ex.te_order,
        title: title || `#${ex.te_order ?? ""}`,
      };
      if (!groups.has(typeLabel)) groups.set(typeLabel, []);
      groups.get(typeLabel).push(row);
    }
    return Array.from(groups.entries())
      .map(([typeLabel, rows]) => ({
        typeLabel,
        rows: rows.sort((a, b) => (a.te_order ?? 0) - (b.te_order ?? 0)),
      }))
      .sort((a, b) => a.typeLabel.localeCompare(b.typeLabel));
  }, [
    editDialogOpen,
    selectedSubtypeNorm,
    list,
    lngBase,
    currentlng,
    t,
  ]);

  const planningDurationDirty = useMemo(() => {
    if (planningDurationBaseline == null) return false;
    return buildPlanningDurationSnapshot(list) !== planningDurationBaseline;
  }, [list, planningDurationBaseline]);
  const planningTotalDurationMinutes = useMemo(
    () => wallClockMinutes(planningLanes),
    [planningLanes]
  );

  useEffect(() => {
    onPlanningDurationDirtyChange?.(planningDurationDirty);
  }, [planningDurationDirty, onPlanningDurationDirtyChange]);

  useEffect(() => {
    // Avoid reporting 0 before the session's exercises have loaded (would look like "0 vs session" mismatch).
    onPlanningTotalDurationChange?.(
      planningDurationBaseline == null ? null : planningTotalDurationMinutes
    );
  }, [
    planningTotalDurationMinutes,
    planningDurationBaseline,
    onPlanningTotalDurationChange,
  ]);

  useEffect(() => {
    fetchExerciseTypes();
  }, []);

  useEffect(() => {
    if (selectedSession && selectedSession.ts_id) {
      console.log("🔍 Exercises - Fetching exercises for session:", selectedSession.ts_id);
      setlist([]); // Clear previous exercises when session changes
      setPlanningDurationBaseline(null);
      getexlist(selectedSession.ts_id);
      loadSubgroups(selectedSession.ts_id);
    } else {
      console.warn("⚠️ Exercises - No valid session selected, clearing exercises");
      setlist([]);
      setPlanningDurationBaseline(null);
      setSelectedExercise(null);
      setSubgroups([]);
    }
  }, [selectedSession?.ts_id]);
  
  // WebSocket listeners for real-time exercise state updates
  useEffect(() => {
    if (!selectedSession?.ts_id) {
      return;
    }

    const user_id = user?.user_id || "coach";
    const ts_id = selectedSession.ts_id;
    const socketRole = canEditPlanning ? "coach" : "player";

    // Join session room as soon as we have a session (do not wait for exercise list fetch).
    socket.emit("joinTrainingSession", { ts_id, user_id, role: socketRole });

    // Listen for exercise state updates
    const handleExerciseStateUpdate = (data) => {
      console.log("🔔 Exercises - exerciseStateUpdate received:", data);

      if (!data?.error && data?.alarm && data?.te_id) {
        const isFinalizedStrict =
          data.te_state === "finalized" || data.te_state === TE_STATE_FINALIZED;
        const isExerciseAlarm =
          !data.alarmType || data.alarmType === "exercise";
        if (isFinalizedStrict && isExerciseAlarm) {
          playEndExerciseSound(data.te_id);
        }
      }

      // Update exercise state
      if (data.te_id) {
        setExerciseStates((prev) => ({
          ...prev,
          [data.te_id]: data.te_state,
        }));

        // Update the exercise in the list array
        setlist((prev) =>
          prev.map((ex) => {
            if (ex.te_id === data.te_id) {
              const next = {
                ...ex,
                te_state: data.te_state,
                tbl_state_te: {
                  ...(ex.tbl_state_te || {}),
                  st_id: data.te_state,
                },
              };
              if (data.te_start_time != null) {
                next.te_start_time = data.te_start_time;
              } else if (
                data.te_state === TE_STATE_STARTED &&
                data.synchronizedStartTime != null &&
                !ex.te_start_time
              ) {
                next.te_start_time = new Date(
                  data.synchronizedStartTime
                ).toISOString();
              }
              if (data.te_end_time != null) {
                next.te_end_time = data.te_end_time;
              }
              return next;
            }
            return ex;
          })
        );

        setSelectedExercise((prev) =>
          prev?.te_id === data.te_id
            ? {
                ...prev,
                te_state: data.te_state,
                tbl_state_te: {
                  ...(prev.tbl_state_te || {}),
                  st_id: data.te_state,
                },
              }
            : prev
        );

        // Initial start/pause payloads include timer fields; apply them here so Planning
        // updates even before separate timerUpdate events (sequence mode used to throttle).
        if (data.timer !== undefined) {
          setExerciseTimers((prev) => ({ ...prev, [data.te_id]: data.timer }));
        }
        if (data.sequenceTimer !== undefined) {
          setSequenceTimers((prev) => ({
            ...prev,
            [data.te_id]: data.sequenceTimer,
          }));
        }
        if (data.currentSequence !== undefined) {
          setCurrentSequences((prev) => ({
            ...prev,
            [data.te_id]: data.currentSequence,
          }));
        }
      }
    };
    
    // Listen for timer updates (may include state info and timer/sequence data)
    const handleTimerUpdate = (data) => {
      // Timer updates might include exercise state info
      if (data.te_id && data.te_state) {
        handleExerciseStateUpdate(data);
      }
      
      // Update exercise timer
      if (data.te_id && data.timer !== undefined) {
        setExerciseTimers(prev => ({
          ...prev,
          [data.te_id]: data.timer
        }));
      }
      
      // Update current sequence and sequence timer if available
      if (data.te_id && data.currentSequence !== undefined) {
        setCurrentSequences(prev => ({
          ...prev,
          [data.te_id]: data.currentSequence
        }));
      }
      
      if (data.te_id && data.sequenceTimer !== undefined) {
        setSequenceTimers(prev => ({
          ...prev,
          [data.te_id]: data.sequenceTimer
        }));
      }
    };
    
    // Listen for sequence updates
    const handleSequenceUpdate = (data) => {
      if (data.alarm && data.alarmType === "sequence") {
        playSequenceAlarmFromServer({
          teId: data.te_id,
          sequenceOrder: data.currentSequence ?? 0,
          remainingSeconds: sequenceRemainingFromPayload(data),
        });
      }
      if (data.te_id) {
        if (data.currentSequence !== undefined) {
          setCurrentSequences(prev => ({
            ...prev,
            [data.te_id]: data.currentSequence
          }));
        }
        if (data.sequenceTimer !== undefined) {
          setSequenceTimers(prev => ({
            ...prev,
            [data.te_id]: data.sequenceTimer
          }));
        }
      }
    };

    // Coach reordered sequences: update local list so players/coach see new order
    const handleSequenceOrderChanged = (data) => {
      if (!data.te_id || !data.sequences || !Array.isArray(data.sequences) || data.sequences.length === 0) return;
      const orderMap = data.sequences.reduce((acc, s) => {
        if (s.tes_id != null) acc[String(s.tes_id)] = s.sequence_order ?? 9999;
        return acc;
      }, {});
      setlist((prev) =>
        prev.map((ex) => {
          if (ex.te_id !== data.te_id || !ex.sequences?.length) return ex;
          const sorted = [...ex.sequences].sort((a, b) => {
            const oa = orderMap[String(a.tes_id)] ?? a.sequence_order ?? 9999;
            const ob = orderMap[String(b.tes_id)] ?? b.sequence_order ?? 9999;
            return oa - ob;
          });
          return { ...ex, sequences: sorted };
        })
      );
      setSelectedExercise((prev) => {
        if (prev?.te_id !== data.te_id || !prev?.sequences?.length) return prev;
        const sorted = [...prev.sequences].sort((a, b) => {
          const oa = orderMap[String(a.tes_id)] ?? a.sequence_order ?? 9999;
          const ob = orderMap[String(b.tes_id)] ?? b.sequence_order ?? 9999;
          return oa - ob;
        });
        return { ...prev, sequences: sorted };
      });
    };

    const mergePlanIntoExercise = (ex, data) => {
      if (!ex || ex.te_id !== data.te_id) return ex;
      const next = {
        ...ex,
        te_duration: data.te_duration ?? ex.te_duration,
        ex_sub_type_id: data.ex_sub_type_id !== undefined ? data.ex_sub_type_id : ex.ex_sub_type_id,
        sub_type_ex: data.sub_type_ex !== undefined ? data.sub_type_ex : ex.sub_type_ex,
        type_ex: data.type_ex !== undefined ? data.type_ex : ex.type_ex,
      };
      if (data.sequences?.length && ex.sequences?.length) {
        const byTes = Object.fromEntries(
          data.sequences.map((s) => [String(s.tes_id), s])
        );
        next.sequences = [...ex.sequences]
          .map((seq) => {
            const u = byTes[String(seq.tes_id)];
            if (!u) return seq;
            return {
              ...seq,
              sequence_duration: u.sequence_duration ?? seq.sequence_duration,
              sequence_order: u.sequence_order ?? seq.sequence_order,
              player_a_role: u.player_a_role ?? seq.player_a_role,
              player_b_role: u.player_b_role ?? seq.player_b_role,
              player_a_id: u.player_a_id !== undefined ? u.player_a_id : seq.player_a_id,
              player_b_id: u.player_b_id !== undefined ? u.player_b_id : seq.player_b_id,
              sub_type_id: u.sub_type_id !== undefined ? u.sub_type_id : seq.sub_type_id,
              sub_type_ex: u.sub_type_ex !== undefined ? u.sub_type_ex : seq.sub_type_ex,
            };
          })
          .sort((a, b) => (a.sequence_order ?? 0) - (b.sequence_order ?? 0));
      }
      return next;
    };

    const handleExercisePlanUpdated = (data) => {
      if (!data?.te_id || data.ts_id !== ts_id) return;
      setlist((prev) => prev.map((ex) => mergePlanIntoExercise(ex, data)));
      setSelectedExercise((prev) =>
        prev && prev.te_id === data.te_id ? mergePlanIntoExercise(prev, data) : prev
      );
    };

    const handleExerciseOrderUpdated = (data) => {
      if (!data?.exercises?.length || data.ts_id !== ts_id) return;
      const orderMap = Object.fromEntries(
        data.exercises.map((e) => [String(e.te_id), e.te_order])
      );
      setlist((prev) =>
        [...prev]
          .map((ex) => ({
            ...ex,
            te_order: orderMap[String(ex.te_id)] ?? ex.te_order,
          }))
          .sort((a, b) => (a.te_order ?? 0) - (b.te_order ?? 0))
      );
      setSelectedExercise((prev) =>
        prev && orderMap[String(prev.te_id)] != null
          ? { ...prev, te_order: orderMap[String(prev.te_id)] }
          : prev
      );
    };

    const handleTrainingBlockExercisesSwapped = (data) => {
      if (!data?.from_te_id || !data?.to_te_id || data.ts_id !== ts_id) return;
      requestPlanningRefresh();
      setSwapSource(null);
    };

    const handleSessionMetaUpdated = (data) => {
      if (!data?.ts_id || data.ts_id !== ts_id) return;
      if (data.ts_duration != null) {
        onSessionMetaUpdate?.({ ts_id: data.ts_id, ts_duration: data.ts_duration });
      }
    };

    socket.on("exerciseStateUpdate", handleExerciseStateUpdate);
    socket.on("timerUpdate", handleTimerUpdate);
    socket.on("sequenceUpdate", handleSequenceUpdate);
    socket.on("sequenceOrderChanged", handleSequenceOrderChanged);
    socket.on("exercisePlanUpdated", handleExercisePlanUpdated);
    socket.on("exerciseOrderUpdated", handleExerciseOrderUpdated);
    socket.on("trainingBlockExercisesSwapped", handleTrainingBlockExercisesSwapped);
    socket.on("sessionMetaUpdated", handleSessionMetaUpdated);

    return () => {
      socket.off("exerciseStateUpdate", handleExerciseStateUpdate);
      socket.off("timerUpdate", handleTimerUpdate);
      socket.off("sequenceUpdate", handleSequenceUpdate);
      socket.off("sequenceOrderChanged", handleSequenceOrderChanged);
      socket.off("exercisePlanUpdated", handleExercisePlanUpdated);
      socket.off("exerciseOrderUpdated", handleExerciseOrderUpdated);
      socket.off("trainingBlockExercisesSwapped", handleTrainingBlockExercisesSwapped);
      socket.off("sessionMetaUpdated", handleSessionMetaUpdated);
    };
  }, [
    selectedSession?.ts_id,
    socket,
    user?.user_id,
    onSessionMetaUpdate,
    canEditPlanning,
  ]);

  useEffect(() => {
    if (!selectedTypeId) {
      setExerciseSubTypes([]);
      return;
    }
    const typeRow = exerciseTypes.find((t) => t.type_id === selectedTypeId);
    if (isCompetencyBlockExerciseType(typeRow)) {
      setExerciseSubTypes([]);
      fetchCompetencyBlocks();
      return;
    }
    if (isSubtypeFreeType(typeRow)) {
      setExerciseSubTypes([]);
      return;
    }
    fetchExerciseSubTypes(selectedTypeId);
  }, [selectedTypeId, exerciseTypes]);

  // Cleanup press-hold timers on unmount
  useEffect(() => {
    return () => {
      if (pressHoldTimer) {
        clearTimeout(pressHoldTimer);
      }
      if (exercisePressHoldTimer) {
        clearTimeout(exercisePressHoldTimer);
      }
    };
  }, [pressHoldTimer, exercisePressHoldTimer]);

  const fetchExerciseTypes = async () => {
    try {
      const response = await axios.get(
        `${ip_back}api/types/getType`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (response.data.status === "success") {
        const raw = response.data.data || [];
        // Exclude "Exercise à table" (BC type – not selectable when adding exercise)
        const types = raw.filter(
          (t) =>
            (t.type_name_fr || "").trim() !== "Exercise à table" &&
            (t.type_name_en || "").trim().toLowerCase() !== "table exercise" &&
            (t.type_name_en || "").trim().toLowerCase() !== "exercises at table"
        );
        setExerciseTypes(types);
        return types;
      }
      console.error("❌ Failed to fetch exercise types:", response.data);
    } catch (error) {
      console.error("❌ Error fetching exercise types:", error);
    }
    return [];
  };

  const fetchExerciseSubTypes = async (typeId) => {
    try {
      const response = await axios.get(
        `${ip_back}api/types/getSubtype?type_id=${typeId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (response.data.status === "success") {
        setExerciseSubTypes(response.data.data || []);
      }
    } catch (error) {
      console.error("Error fetching exercise subtypes:", error);
    }
  };

  const fetchCompetencyBlocks = async () => {
    try {
      const response = await complist();
      setCompetencyBlocks(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching competency blocks:", error);
    }
  };

  const stampSequencesWithKind = (kindId) => {
    if (!kindId) return;
    setEditSequences((prev) =>
      prev.map((seq) => ({
        ...seq,
        sub_type_id: kindId,
        lastValidSubTypeId: kindId,
      }))
    );
  };

  const handleEditTypeChange = (nextTypeId) => {
    setSelectedTypeId(nextTypeId);
    setSelectedSubTypeId(null);
    setEditSequences((prev) =>
      prev.map((seq) => ({
        ...seq,
        sub_type_id: null,
        lastValidSubTypeId: null,
      }))
    );
    const nextType = exerciseTypes.find((row) => row.type_id === nextTypeId);
    if (isCompetencyBlockExerciseType(nextType)) {
      setExerciseSubTypes([]);
      fetchCompetencyBlocks();
      return;
    }
    if (isSubtypeFreeType(nextType)) {
      setExerciseSubTypes([]);
      return;
    }
  };

  const handleTrainingBlockKindChange = (kindId) => {
    setSelectedSubTypeId(kindId || null);
    stampSequencesWithKind(kindId);
  };

  const handleOpenEditDialog = async (exercise) => {
    setEditingExercise(exercise);
    const duration = exercise.te_duration || "";
    setEditDuration(duration);
    setLastValidDuration(duration); // Store initial valid duration
    setEditCoachTools(coachToolsFromExercise(exercise));
    
    const typeId = exercise.type_ex?.type_id || exercise.type_id || null;
    const subTypeId = trainingBlockKindId(exercise);
    
    setSelectedTypeId(typeId);
    setSelectedSubTypeId(subTypeId);
    setSelectedCatalogExercise(
      exercise.ex_id
        ? {
            ex_id: exercise.ex_id,
            ex_name: exercise.ex_name,
            ex_name_en: exercise.ex_name_en,
            ex_name_fr: exercise.ex_name_fr,
            ex_name_de: exercise.ex_name_de,
            ex_name_es: exercise.ex_name_es,
            type_id: typeId,
          }
        : null
    );
    
    // Ensure types are loaded
    let types = exerciseTypes;
    if (types.length === 0) {
      types = (await fetchExerciseTypes()) || exerciseTypes;
    }
    
    // Load subtypes or competency blocks for the current type
    if (typeId) {
      const typeRow =
        types.find((row) => String(row.type_id) === String(typeId)) ||
        exercise.type_ex;
      if (isCompetencyBlockExerciseType(typeRow)) {
        await fetchCompetencyBlocks();
      } else if (!isSubtypeFreeType(typeRow)) {
        await fetchExerciseSubTypes(typeId);
      }
    }
    
    // Initialize sequences with their durations, subtypes, and player roles
    // Sort sequences by sequence_order in ascending order
    if (exercise.sequences && Array.isArray(exercise.sequences)) {
      const sortedSequences = [...exercise.sequences].sort((a, b) => {
        const orderA = a.sequence_order || 0;
        const orderB = b.sequence_order || 0;
        return orderA - orderB;
      });
      setEditSequences(sortedSequences.map(seq => ({
        tes_id: seq.tes_id,
        sequence_duration: seq.sequence_duration || "",
        lastValidDuration: seq.sequence_duration || "",
        sub_type_id: seq.sub_type_id || null,
        lastValidSubTypeId: seq.sub_type_id || null,
        player_a_role: seq.player_a_role || "active",
        player_b_role: seq.player_b_role || "sparring",
        player_a_id: seq.player_a_id || null,
        player_b_id: seq.player_b_id || null,
        sequence_order: seq.sequence_order || 0,
      })));
    } else {
      setEditSequences([]);
    }
    
    setEditDialogOpen(true);
    console.log("✅ Edit dialog opened, editingExercise:", exercise);
  };

  const handleCloseEditDialog = () => {
    // Clear any active timers
    if (pressHoldTimer) {
      clearTimeout(pressHoldTimer);
      setPressHoldTimer(null);
    }
    
    setEditDialogOpen(false);
    setExchangeDialogOpen(false);
    setExchangingExercise(false);
    setEditingExercise(null);
    setEditDuration("");
    setLastValidDuration("");
    setSelectedTypeId(null);
    setSelectedSubTypeId(null);
    setSelectedCatalogExercise(null);
    setEditSequences([]);
    setIsDragging(false);
    setDraggedSequenceIndex(null);
    setDragOverSequenceIndex(null);
  };

  const handleSequenceDurationChange = (index, value) => {
    const updatedSequences = [...editSequences];
    updatedSequences[index] = {
      ...updatedSequences[index],
      sequence_duration: value,
      // Keep last valid duration if value is not empty
      lastValidDuration: value !== "" ? value : updatedSequences[index].lastValidDuration,
    };
    setEditSequences(updatedSequences);
  };

  const handleSequenceSubTypeChange = async (index, subTypeId) => {
    const updatedSequences = [...editSequences];
    updatedSequences[index] = {
      ...updatedSequences[index],
      sub_type_id: subTypeId,
      lastValidSubTypeId: subTypeId || updatedSequences[index].lastValidSubTypeId,
    };
    setEditSequences(updatedSequences);
    
    // If subtype changed, we might need to reload subtypes if type changed
    // But for now, we'll keep the same subtype list since all sequences should have the same type
  };

  const handleSequenceRoleChange = (index, roleType, value) => {
    const updatedSequences = [...editSequences];
    updatedSequences[index] = {
      ...updatedSequences[index],
      [roleType]: value,
    };
    setEditSequences(updatedSequences);
  };

  // Drag and Drop handlers for sequences
  const handleSequenceDragStart = (tesId, index, event) => {
    // Prevent default to allow custom drag behavior
    if (event.type === 'touchstart' || event.touches) {
      // Don't prevent default immediately - let user interact with form fields
      // Only start drag after press-hold
      const touch = event.touches ? event.touches[0] : null;
      const startX = touch ? touch.clientX : 0;
      const startY = touch ? touch.clientY : 0;
      
      // Start press-hold timer for mobile
      const timer = setTimeout(() => {
        setIsDragging(true);
        setDraggedSequenceIndex(tesId);
        // Add haptic feedback if available
        if (navigator.vibrate) {
          navigator.vibrate(50);
        }
        // Prevent scrolling while dragging
        if (event.preventDefault) {
          event.preventDefault();
        }
      }, 400); // 400ms press-hold delay for better UX
      setPressHoldTimer(timer);
    } else {
      // Desktop: immediate drag start
      setIsDragging(true);
      setDraggedSequenceIndex(tesId);
    }
  };

  const handleSequenceDragEnd = () => {
    // Clear press-hold timer if it exists
    if (pressHoldTimer) {
      clearTimeout(pressHoldTimer);
      setPressHoldTimer(null);
    }
    
    if (draggedSequenceIndex !== null && dragOverSequenceIndex !== null && draggedSequenceIndex !== dragOverSequenceIndex) {
      // Get current sorted sequences
      const sortedSequences = [...editSequences].sort((a, b) => {
        const orderA = a.sequence_order || 0;
        const orderB = b.sequence_order || 0;
        return orderA - orderB;
      });
      
      // Convert to strings for consistent comparison (tes_id might be number or string)
      const draggedIdStr = String(draggedSequenceIndex);
      const dragOverIdStr = String(dragOverSequenceIndex);
      
      const fromIndex = sortedSequences.findIndex(seq => String(seq.tes_id) === draggedIdStr);
      const toIndex = sortedSequences.findIndex(seq => String(seq.tes_id) === dragOverIdStr);
      
      if (fromIndex !== -1 && toIndex !== -1 && fromIndex !== toIndex) {
        // Reorder sequences
        const newSequences = [...sortedSequences];
        const draggedItem = newSequences[fromIndex];
        
        // Remove dragged item
        newSequences.splice(fromIndex, 1);
        
        // Calculate new insertion index
        // If dragging down (fromIndex < toIndex), we need to adjust because we removed an item
        // When dragging down, indices shift down by 1 after removal, so subtract 1
        // When dragging up, we can use toIndex directly
        const newToIndex = fromIndex < toIndex ? toIndex - 1 : toIndex;
        
        // Insert at new position
        newSequences.splice(newToIndex, 0, draggedItem);
        
        // Update sequence_order for all sequences
        const updatedSequences = newSequences.map((seq, idx) => ({
          ...seq,
          sequence_order: idx + 1,
        }));
        
        // Update editSequences with new order (preserve all other properties)
        setEditSequences(prevSequences => {
          return updatedSequences.map(updatedSeq => {
            const prevSeq = prevSequences.find(p => p.tes_id === updatedSeq.tes_id);
            return {
              ...prevSeq,
              ...updatedSeq,
            };
          });
        });
      }
    }
    
    setIsDragging(false);
    setDraggedSequenceIndex(null);
    setDragOverSequenceIndex(null);
  };

  const handleSequenceDragOver = (tesId, event) => {
    event.preventDefault();
    if (isDragging && draggedSequenceIndex !== null && draggedSequenceIndex !== tesId) {
      setDragOverSequenceIndex(tesId);
    }
  };

  const handleSequenceTouchMove = (event) => {
    if (pressHoldTimer) {
      // Cancel press-hold if user moves finger before timer completes
      clearTimeout(pressHoldTimer);
      setPressHoldTimer(null);
    }
  };

  const handleSequenceTouchEnd = () => {
    // Clear press-hold timer on touch end
    if (pressHoldTimer) {
      clearTimeout(pressHoldTimer);
      setPressHoldTimer(null);
    }
    if (isDragging) {
      handleSequenceDragEnd();
    } else {
      // If drag didn't start, just reset
      setIsDragging(false);
      setDraggedSequenceIndex(null);
      setDragOverSequenceIndex(null);
    }
  };

  const exchangeFilterMeta = useMemo(() => {
    if (!editingExercise) {
      return { typeId: null, subTypeId: null, cbId: null, label: "" };
    }
    const typeRow = exerciseTypes.find((t) => t.type_id === selectedTypeId);
    const isCompetencyBlock =
      isCompetencyBlockExerciseType(typeRow) ||
      isCompetencyBlockExerciseType(editingExercise?.type_ex);
    const kindId = nestedId(selectedSubTypeId, ["cb_id", "sub_type_id"]) ||
      trainingBlockKindId(editingExercise);
    const typeId = selectedTypeId || editingExercise?.type_ex?.type_id || editingExercise?.type_id || null;
    const rawSub = selectedSubTypeId || editingExercise?.sub_type_ex?.sub_type_id || null;
    const subTypeId =
      rawSub && typeof rawSub === "object" ? rawSub.sub_type_id || rawSub.cb_id || null : rawSub;
    const cbRow = competencyBlocks.find((cb) => String(cb.cb_id) === String(kindId));
    const label = isCompetencyBlock
      ? localizedCbName(cbRow, currentlng.split("-")[0]) ||
        localizedCbName(editingExercise.ex_sub_type_id, currentlng.split("-")[0]) ||
        localizedCbName(editingExercise.competency_block, currentlng.split("-")[0]) ||
        t("competencyblock") ||
        "Competency block"
      : exerciseSubTypes.find((st) => String(st.sub_type_id) === String(subTypeId))?.[
          `sub_type_name_${currentlng}`
        ] ||
        editingExercise?.sub_type_ex?.[`sub_type_name_${currentlng}`] ||
        editingExercise?.sub_type_ex?.sub_type_name_en ||
        editingExercise?.type_ex?.[`type_name_${currentlng}`] ||
        "";
    return {
      typeId: isCompetencyBlock ? null : typeId,
      subTypeId: isCompetencyBlock ? null : subTypeId,
      cbId: isCompetencyBlock ? kindId : null,
      label,
    };
  }, [
    editingExercise,
    selectedTypeId,
    selectedSubTypeId,
    exerciseTypes,
    exerciseSubTypes,
    competencyBlocks,
    currentlng,
    t,
  ]);

  const handleExchangeExercise = async (ex) => {
    if (!ex?.ex_id || !editingExercise?.te_id) return;
    try {
      setExchangingExercise(true);
      // Only send cb_id for competency-block *placeholders* (no catalog ex yet).
      // Do not send catalog competency_block / group cb_id on ex→ex swaps — the API
      // used to treat any cb_id as a CB-slot lookup and 500 when ex_sub_type_id was null.
      const cbId =
        editingExercise?.ex_sub_type_id?.cb_id ||
        (editingExercise?.type_ex?.type_name_en === BLOCKS_OF_COMPETENCY_TYPE_EN
          ? editingExercise?.competency_block?.cb_id
          : null) ||
        null;
      if (editingExercise.ex_id) {
        await updateexercise({
          te_id: editingExercise.te_id,
          replace_ex_id: ex.ex_id,
          existing_ex_id: editingExercise.ex_id,
        });
      } else {
        await addexercise({
          ts_id: selectedSession.ts_id,
          te_id: editingExercise.te_id,
          allow_duration_exceed: true,
          tsg_id: editingExercise.tsg_id || selectedTsgId || undefined,
          ex_ids: [
            {
              ex_id: ex.ex_id,
              duration: parseInt(String(editingExercise.te_duration), 10) || 10,
              steps: "1",
              ...(cbId ? { cb_id: cbId } : {}),
            },
          ],
        });
      }
      setsuccess(
        editingExercise.ex_id
          ? t("exerciseReplaced") || "Exercise replaced successfully"
          : t("exerciseAdded") || "Exercise added successfully"
      );
      setSnackbarSeverity("success");
      setopen(true);
      setExchangeDialogOpen(false);
      handleCloseEditDialog();
      getexlist(selectedSession.ts_id);
      setTimeout(() => setopen(false), 2000);
    } catch (err) {
      seterror(err?.message || t("errorReplacingExercise") || "Error replacing exercise");
      setSnackbarSeverity("error");
      setopen(true);
    } finally {
      setExchangingExercise(false);
    }
  };

  // Calculate remaining time for sequences
  const calculateRemainingTime = () => {
    const totalDuration = parseDurationMinutes(editDuration || lastValidDuration || 0);
    const sequencesTotal = editSequences.reduce((sum, seq) => {
      return sum + parseDurationMinutes(seq.sequence_duration || seq.lastValidDuration || 0);
    }, 0);
    return totalDuration - sequencesTotal;
  };

  const handleDurationChange = (value) => {
    setEditDuration(value);
    // Keep last valid duration if value is not empty
    if (value !== "") {
      setLastValidDuration(value);
    }
  };

  const mapExerciseListFromResponse = (raw) =>
    (raw || [])
      .map((ex) => ({
        ...ex,
        sequences: (ex.sequences || [])
          .slice()
          .sort((a, b) => (a.sequence_order ?? 9999) - (b.sequence_order ?? 9999)),
      }))
      .sort((a, b) => (a.te_order ?? 0) - (b.te_order ?? 0));

  const handleDeleteSequence = async (tesId, seqIdx) => {
    if (!tesId) {
      setEditSequences((prev) => {
        if (prev.length <= 1) return prev;
        return prev
          .filter((_, idx) => idx !== seqIdx)
          .map((seq, idx) => ({ ...seq, sequence_order: idx + 1 }));
      });
      return;
    }
    if (!editingExercise?.te_id || !selectedSession?.ts_id) return;
    if (editSequences.length <= 1) {
      seterror(t("sequenceMinOne") || "At least one sequence is required");
      return;
    }
    if (!window.confirm(t("confirmDeleteSequence") || "Remove this sequence?")) return;
    try {
      await deleteTrainingExerciseSequence({
        tes_id: tesId,
        te_id: editingExercise.te_id,
        ts_id: selectedSession.ts_id,
      });
      const response = await sessionexlist({ ts_id: selectedSession.ts_id });
      const normalized = mapExerciseListFromResponse(response.data.data || []);
      setlist(normalized);
      const ex = normalized.find((e) => e.te_id === editingExercise.te_id);
      if (ex) {
        setEditingExercise(ex);
        const dur = ex.te_duration || "";
        setEditDuration(dur);
        setLastValidDuration(dur);
        if (ex.sequences && Array.isArray(ex.sequences)) {
          const sortedSequences = [...ex.sequences].sort((a, b) => {
            const orderA = a.sequence_order || 0;
            const orderB = b.sequence_order || 0;
            return orderA - orderB;
          });
          setEditSequences(
            sortedSequences.map((seq) => ({
              tes_id: seq.tes_id,
              sequence_duration: seq.sequence_duration || "",
              lastValidDuration: seq.sequence_duration || "",
              sub_type_id: seq.sub_type_id || null,
              lastValidSubTypeId: seq.sub_type_id || null,
              player_a_role: seq.player_a_role || "active",
              player_b_role: seq.player_b_role || "sparring",
              player_a_id: seq.player_a_id || null,
              player_b_id: seq.player_b_id || null,
              sequence_order: seq.sequence_order || 0,
            }))
          );
        } else {
          setEditSequences([]);
        }
      }
      setsuccess(t("sequenceDeleted") || "Sequence removed");
      setopen(true);
      setTimeout(() => setopen(false), 2000);
    } catch (error) {
      console.error("Delete sequence:", error);
      seterror(error.message || t("errorDeletingSequence") || "Could not remove sequence");
    }
  };

  const handleAddSequence = () => {
    const total = parseInt(String(editDuration || lastValidDuration || "0"), 10) || 0;
    const used = editSequences.reduce(
      (sum, seq) => sum + (parseInt(String(seq.sequence_duration || seq.lastValidDuration || "0"), 10) || 0),
      0
    );
    const duration = Math.max(1, total > used ? total - used : 1);
    const subTypeId =
      selectedSubTypeId ||
      editSequences[0]?.sub_type_id ||
      editSequences[0]?.lastValidSubTypeId ||
      null;
    const last = editSequences[editSequences.length - 1];
    const swapped = (last?.player_a_role || "active") === "active";
    setEditSequences((prev) => [
      ...prev,
      {
        tes_id: null,
        sequence_duration: String(duration),
        lastValidDuration: String(duration),
        sub_type_id: subTypeId,
        lastValidSubTypeId: subTypeId,
        player_a_role: swapped ? "sparring" : "active",
        player_b_role: swapped ? "active" : "sparring",
        player_a_id: last?.player_a_id || null,
        player_b_id: last?.player_b_id || null,
        sequence_order: prev.length + 1,
      },
    ]);
  };

  const applySequenceLayout = (layout) => {
    const total = parseInt(String(editDuration || lastValidDuration || "0"), 10) || 0;
    if (total <= 0) return;
    const base = editSequences[0] || {};
    const subTypeId =
      selectedSubTypeId || base.sub_type_id || base.lastValidSubTypeId || null;
    const playerA = base.player_a_id || null;
    const playerB = base.player_b_id || null;
    if (layout === "together") {
      setEditSequences([
        {
          tes_id: base.tes_id || null,
          sequence_duration: String(total),
          lastValidDuration: String(total),
          sub_type_id: subTypeId,
          lastValidSubTypeId: subTypeId,
          player_a_role: "active",
          player_b_role: "active",
          player_a_id: playerA,
          player_b_id: playerB,
          sequence_order: 1,
        },
      ]);
      return;
    }
    const half = Math.max(1, Math.floor(total / 2));
    const rest = Math.max(1, total - half);
    setEditSequences([
      {
        tes_id: base.tes_id || null,
        sequence_duration: String(half),
        lastValidDuration: String(half),
        sub_type_id: subTypeId,
        lastValidSubTypeId: subTypeId,
        player_a_role: "active",
        player_b_role: "sparring",
        player_a_id: playerA,
        player_b_id: playerB,
        sequence_order: 1,
      },
      {
        tes_id: editSequences[1]?.tes_id || null,
        sequence_duration: String(rest),
        lastValidDuration: String(rest),
        sub_type_id: subTypeId,
        lastValidSubTypeId: subTypeId,
        player_a_role: "sparring",
        player_b_role: "active",
        player_a_id: playerA,
        player_b_id: playerB,
        sequence_order: 2,
      },
    ]);
  };

  const handleSaveEdit = async () => {
    if (!editingExercise) return;

    // Use last valid duration if current duration is empty
    const finalDurationRaw = editDuration || lastValidDuration;
    const finalDuration = formatMinutesForStorage(finalDurationRaw);
    
    // Validate that duration is not empty
    if (!finalDuration || !(parseDurationMinutes(finalDuration) > 0)) {
      seterror(t("durationRequired") || "Duration is required");
      return;
    }

    try {
      const typeRow = exerciseTypes.find((row) => row.type_id === selectedTypeId);
      const editingAsCompetency = isCompetencyBlockExerciseType(typeRow);
      const rawKindId = nestedId(selectedSubTypeId, ["cb_id", "sub_type_id"]);
      const originalTypeId =
        editingExercise.type_ex?.type_id || editingExercise.type_id || null;
      const originalKindId = trainingBlockKindId(editingExercise);
      const typeChanged =
        selectedTypeId && String(selectedTypeId) !== String(originalTypeId || "");

      // Only send a kind id that matches the selected type (CB id vs skill subtype).
      let kindId = rawKindId;
      if (editingAsCompetency) {
        if (
          rawKindId &&
          competencyBlocks.length > 0 &&
          !competencyBlocks.some(
            (cb) => String(cb.cb_id) === String(rawKindId)
          )
        ) {
          kindId = null;
        }
        if (!kindId) {
          seterror(
            t("selectCompetencyBlockRequired") ||
              "Select a competency block for this training type"
          );
          setSnackbarSeverity("error");
          setopen(true);
          return;
        }
      } else if (selectedTypeId && !isSubtypeFreeType(typeRow)) {
        if (
          rawKindId &&
          exerciseSubTypes.length > 0 &&
          !exerciseSubTypes.some(
            (st) => String(st.sub_type_id) === String(rawKindId)
          )
        ) {
          kindId = null;
        }
        if (!kindId) {
          seterror(
            t("selectSubtypeRequired") ||
              "Select an exercise subtype for this training type"
          );
          setSnackbarSeverity("error");
          setopen(true);
          return;
        }
      } else {
        kindId = null;
      }

      const kindChanged =
        kindId && String(kindId) !== String(originalKindId || "");

      const params = {
        te_id: editingExercise.te_id,
        ts_id: selectedSession.ts_id,
        te_duration: finalDuration,
        allow_duration_exceed: true,
      };

      if (typeChanged || (editingAsCompetency && kindChanged)) {
        params.ex_id = null;
      } else if (selectedCatalogExercise?.ex_id || editingExercise.ex_id) {
        params.ex_id =
          selectedCatalogExercise?.ex_id || editingExercise.ex_id || null;
      }

      if (selectedTypeId) {
        params.type_id = selectedTypeId;
      }
      if (kindId) {
        params.sub_type_id = kindId;
      }

      if (isOffTableExercise(editingExercise) || isOffTableExerciseType(typeRow)) {
        params.te_coach_tools = {
          chrono: Boolean(editCoachTools.chrono),
          count: Boolean(editCoachTools.count),
          count_label: editCoachTools.count
            ? String(editCoachTools.count_label || "").trim()
            : "",
        };
      }

      // Exercise row stores type_id (type-only / retag) and ex_sub_type_id
      // (subtype or competency-block id). Sequences copy the same kind id.

      // Add sequences with their durations and subtypes if they exist.
      // Pass per-sequence player IDs through to the backend so TE_SEQUENCES
      // exercises persist their authoritative roster (sequence.player_a_id /
      // player_b_id). Coaches can override per-sequence assignments via the
      // per-sequence selectors below; otherwise we forward the existing values.
      if (editSequences.length > 0) {
        const sortedSequences = [...editSequences].sort((a, b) => {
          const orderA = a.sequence_order || 0;
          const orderB = b.sequence_order || 0;
          return orderA - orderB;
        });
        const retagSequences = Boolean(typeChanged || kindChanged);

        params.sequences = sortedSequences.map((seq, idx) => ({
          tes_id: seq.tes_id,
          sequence_duration:
            formatMinutesForStorage(
              seq.sequence_duration || seq.lastValidDuration || 0
            ) || 0,
          sub_type_id: retagSequences
            ? kindId
            : seq.sub_type_id || seq.lastValidSubTypeId || kindId || null,
          sequence_order: seq.sequence_order || idx + 1,
          player_a_role: seq.player_a_role || "active",
          player_b_role: seq.player_b_role || "sparring",
          player_a_id: seq.player_a_id ?? null,
          player_b_id: seq.player_b_id ?? null,
        }));
      }

      const response = await editexercise(params);
      setsuccess(response.data?.message || t("exerciseUpdated") || "Exercise updated successfully");
      setSnackbarSeverity("success");
      setopen(true);
      handleCloseEditDialog();
      getexlist(selectedSession.ts_id);
      setTimeout(() => {
        setopen(false);
      }, 2000);
    } catch (error) {
      console.error("Error saving exercise edit:", error);
      const errMsg =
        error?.message ||
        error?.response?.data?.message ||
        t("errorSaving") ||
        "Error saving changes";
      seterror(errMsg);
      setSnackbarSeverity("error");
      setopen(true);
    }
  };

  const getexlist = async (id) => {
    sessionExerciseListLoadCountRef.current += 1;
    if (sessionExerciseListLoadCountRef.current === 1) {
      setSessionExerciseListLoading(true);
    }
    try {
      const params = {
        ts_id: id,
      };
      const response = await sessionexlist(params);
      const raw = response.data.data || [];
      // Ensure sequences run in order 1 to N by sequence_order
      const normalized = raw
        .map((ex) => ({
          ...ex,
          sequences: (ex.sequences || [])
            .slice()
            .sort((a, b) => (a.sequence_order ?? 9999) - (b.sequence_order ?? 9999)),
        }))
        .sort((a, b) => (a.te_order ?? 0) - (b.te_order ?? 0));
      setlist(normalized);
      setPlanningDurationBaseline(buildPlanningDurationSnapshot(normalized));
      return normalized;
    } catch (error) {
      console.log(error);
      return [];
    } finally {
      sessionExerciseListLoadCountRef.current -= 1;
      if (sessionExerciseListLoadCountRef.current <= 0) {
        sessionExerciseListLoadCountRef.current = 0;
        setSessionExerciseListLoading(false);
      }
    }
  };

  const loadSubgroups = useCallback(async (tsId) => {
    if (!tsId) {
      setSubgroups([]);
      return [];
    }
    try {
      const response = await listSessionSubgroups({ ts_id: tsId });
      const data = response?.data?.data || [];
      setSubgroups(data);
      setSelectedTsgId((prev) => {
        if (prev && data.some((s) => String(s.tsg_id) === String(prev))) return prev;
        const main = data.find((s) => s.is_main) || data[0];
        const next = main?.tsg_id || null;
        persistPlanningTsgId(next);
        return next;
      });
      return data;
    } catch (error) {
      console.warn("loadSubgroups:", error);
      return [];
    }
  }, []);

  const selectPlanningLane = useCallback((tsgId) => {
    setSelectedTsgId(tsgId);
    persistPlanningTsgId(tsgId);
    templateTargetTsgIdRef.current = tsgId || null;
  }, []);
  const handleex = (i) => {
    setSelectedExercise(i);
  };

  const handleQuickCompetencyBlockChange = async (block, cbId) => {
    if (!canEditPlanning || quickCbBusy || !selectedSession?.ts_id || !cbId) return;
    const row =
      list.find((ex) => String(ex.te_id) === String(block?.te_id)) || block;
    if (!row?.te_id) return;
    if (String(trainingBlockKindId(row) || "") === String(cbId)) return;
    const typeId = row.type_ex?.type_id || row.tbl_type_ex?.type_id || row.type_id;
    const duration =
      formatMinutesForStorage(parseDurationMinutes(row.te_duration)) ||
      formatMinutesForStorage(getExerciseDurationMinutesForPlanning(row));
    if (!typeId || !duration) return;

    const params = {
      te_id: row.te_id,
      ts_id: selectedSession.ts_id,
      te_duration: duration,
      allow_duration_exceed: true,
      type_id: typeId,
      sub_type_id: cbId,
      // A catalog drill belongs to its block; changing the block clears it.
      ex_id: null,
    };
    if (Array.isArray(row.sequences) && row.sequences.length > 0) {
      params.sequences = [...row.sequences]
        .sort((a, b) => (a.sequence_order || 0) - (b.sequence_order || 0))
        .map((seq, idx) => ({
          tes_id: seq.tes_id,
          sequence_duration:
            formatMinutesForStorage(parseDurationMinutes(seq.sequence_duration)) || 0,
          sub_type_id: cbId,
          sequence_order: seq.sequence_order || idx + 1,
          player_a_role: seq.player_a_role || "active",
          player_b_role: seq.player_b_role || "sparring",
          player_a_id: seq.player_a_id ?? null,
          player_b_id: seq.player_b_id ?? null,
        }));
    }

    setQuickCbBusy(true);
    try {
      await editexercise(params);
      setsuccess(t("competencyBlockUpdated") || "Competency block updated");
      setSnackbarSeverity("success");
      setopen(true);
      const next = await getexlist(selectedSession.ts_id);
      const refreshed = next.find((ex) => String(ex.te_id) === String(row.te_id));
      if (refreshed) setSelectedExercise(refreshed);
      setTimeout(() => setopen(false), 2000);
    } catch (error) {
      console.error("Error changing competency block:", error);
      seterror(
        error?.response?.data?.message ||
          error?.message ||
          t("errorSaving") ||
          "Error saving changes"
      );
      setSnackbarSeverity("error");
      setopen(true);
    } finally {
      setQuickCbBusy(false);
    }
  };

  const handleSwapTrainingBlocks = async (fromEx, toEx) => {
    if (!canEditPlanning || swapBusy || !selectedSession?.ts_id) return;
    if (
      !canSwapPlanningBlockExercises(fromEx, toEx, {
        fromLocked: lockedPlanningTeIds.has(String(fromEx?.te_id)),
        toLocked: lockedPlanningTeIds.has(String(toEx?.te_id)),
      })
    ) {
      seterror(t("cannotSwapExercise") || "Those training blocks cannot be swapped");
      setSnackbarSeverity("error");
      setopen(true);
      return;
    }
    const fromId = fromEx.te_id;
    const toId = toEx.te_id;
    setSwapBusy(true);
    setlist((prev) => {
      const next = swapTrainingBlockExercisesInList(prev, fromId, toId);
      const pick = (row) =>
        row ? next.find((ex) => String(ex.te_id) === String(row.te_id)) || row : row;
      setSelectedExercise((sel) => pick(sel));
      setDetailsExercise((sel) => pick(sel));
      const moved = next.find((ex) => String(ex.te_id) === String(fromId));
      if (moved?.tsg_id) selectPlanningLane(moved.tsg_id);
      return next;
    });
    setSwapSource(null);
    try {
      await swapTrainingBlockExercises({
        ts_id: selectedSession.ts_id,
        from_te_id: fromId,
        to_te_id: toId,
      });
      setsuccess(t("exercisesSwapped") || "Training blocks swapped");
      setSnackbarSeverity("success");
      setopen(true);
      await getexlist(selectedSession.ts_id);
      setTimeout(() => setopen(false), 2000);
    } catch (err) {
      await getexlist(selectedSession.ts_id);
      seterror(
        err?.message || t("cannotSwapExercise") || "Could not swap those exercises"
      );
      setSnackbarSeverity("error");
      setopen(true);
    } finally {
      setSwapBusy(false);
    }
  };

  const handleSyncBlockExercise = async ({ target_tsg_ids, mode }) => {
    if (
      !canEditPlanning ||
      syncBlockBusy ||
      !selectedSession?.ts_id ||
      !syncBlockSource?.te_id
    ) {
      return;
    }
    if (!Array.isArray(target_tsg_ids) || target_tsg_ids.length === 0) return;
    setSyncBlockBusy(true);
    try {
      await syncBlockExercise({
        ts_id: selectedSession.ts_id,
        source_te_id: syncBlockSource.te_id,
        target_tsg_ids,
        mode: mode || "overwrite",
      });
      setSyncBlockSource(null);
      setsuccess(t("syncBlockExerciseSuccess") || "Training block synced");
      setSnackbarSeverity("success");
      setopen(true);
      await getexlist(selectedSession.ts_id);
      await loadSubgroups(selectedSession.ts_id);
      setTimeout(() => setopen(false), 2000);
    } catch (err) {
      await getexlist(selectedSession.ts_id);
      seterror(
        err?.message ||
          t("syncBlockExerciseError") ||
          "Could not sync that training block"
      );
      setSnackbarSeverity("error");
      setopen(true);
    } finally {
      setSyncBlockBusy(false);
    }
  };

  useEffect(() => {
    const lane = planningLanes.find((l) => String(l.tsg_id) === String(selectedTsgId));
    persistPlanningFocus({
      page: "planning",
      ts_id: selectedSession?.ts_id || null,
      gr_id: resolveSessionGroupId(selectedSession, selectedgrp) || null,
      tsg_id: selectedTsgId || lane?.tsg_id || null,
      station_name: lane?.name || (lane?.is_main ? "Main group" : null),
      is_main: Boolean(lane?.is_main),
      te_id: selectedExercise?.te_id || detailsExercise?.te_id || null,
      exercise_name:
        exerciseLabel(detailsExercise || selectedExercise, currentlng) || null,
    });
  }, [
    planningLanes,
    selectedTsgId,
    selectedExercise,
    detailsExercise,
    selectedSession,
    selectedgrp,
    currentlng,
  ]);

  useEffect(() => () => persistPlanningFocus(null), []);

  useEffect(() => {
    const onRefresh = () => {
      if (!selectedSession?.ts_id) return;
      getexlist(selectedSession.ts_id);
      loadSubgroups(selectedSession.ts_id);
    };
    window.addEventListener(PLANNING_REFRESH_EVENT, onRefresh);
    return () => window.removeEventListener(PLANNING_REFRESH_EVENT, onRefresh);
  }, [selectedSession?.ts_id, loadSubgroups]);

  const navigate = useNavigate();

  const navigateToPlayerSummary = useCallback(
    (exercise, e) => {
      e?.stopPropagation?.();
      const target =
        viewerPlayerId != null ? { targetUserId: viewerPlayerId } : {};
      navigate("/Training_Summary", {
        state: {
          selectedSession,
          selectedgrp,
          exercise,
          ...target,
        },
      });
    },
    [navigate, selectedSession, selectedgrp, viewerPlayerId]
  );

  const handledeleteex = async (id) => {
    try {
      const params = {
        ts_id: selectedSession.ts_id,
        te_id: id,
      };
      await sessiondeleteex(params);
      // Optimistic local update so remaining-duration messages recalculate immediately.
      setlist((prev) => prev.filter((ex) => String(ex.te_id) !== String(id)));
      setSelectedExercise((prev) =>
        prev && String(prev.te_id) === String(id) ? null : prev
      );
      setEditingExercise((prev) =>
        prev && String(prev.te_id) === String(id) ? null : prev
      );
      setDetailsExercise((prev) =>
        prev && String(prev.te_id) === String(id) ? null : prev
      );
      setSyncBlockSource((prev) =>
        prev && String(prev.te_id) === String(id) ? null : prev
      );
      setSwapSource((prev) =>
        prev && String(prev.te_id) === String(id) ? null : prev
      );
      setshowoption(false);

      // Then refresh from backend to keep ordering/state in sync.
      await getexlist(selectedSession.ts_id);
      setshowoption(false);
      return true;
    } catch (error) {
      console.log(error);
      return false;
    }
  };

  const handleOpenDeleteDialog = (exercise) => {
    setExerciseToDelete(exercise);
    setDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setDeleteDialogOpen(false);
    setExerciseToDelete(null);
  };

  const handleConfirmDelete = async () => {
    if (!exerciseToDelete?.te_id) return;
    const deleted = await handledeleteex(exerciseToDelete.te_id);
    if (deleted) {
      setsuccess(t("exerciseDeleted") || "Exercise deleted successfully");
      setopen(true);
      setTimeout(() => setopen(false), 2000);
      handleCloseDeleteDialog();
    }
  };

  const handlemin = (e, i) => {
    const raw = e.target.value;
    setlist((prev) =>
      mapListWithSyncedDuration(
        prev,
        i,
        raw,
        subgroups,
        distributeExerciseMinutesAcrossSequences
      )
    );
  };

  const handleSequenceDurationOnCard = (exercise, tesId, rawValue) => {
    setlist((prev) => {
      const updated = prev.map((item) => {
        if (item.te_id !== exercise.te_id) return item;
        const sequences = (item.sequences || []).map((seq) =>
          String(seq.tes_id) === String(tesId) ? { ...seq, sequence_duration: rawValue } : seq
        );
        const total = sequences.reduce(
          (acc, seq) => acc + parseDurationMinutes(seq?.sequence_duration),
          0
        );
        return {
          ...item,
          sequences,
          te_duration: formatMinutesForStorage(total),
        };
      });
      const source = updated.find((item) => item.te_id === exercise.te_id);
      if (!source) return updated;
      return mapListWithSyncedDuration(
        updated,
        source,
        source.te_duration,
        subgroups,
        distributeExerciseMinutesAcrossSequences,
        { includeSource: false }
      );
    });
  };

  const buildEditExerciseParamsFromPlanningCard = (ex) => {
    if (!ex?.te_id || !selectedSession?.ts_id) return { error: null, params: null };
    if (!ex.ex_id) {
      return {
        error:
          t("selectExerciseFirst") ||
          "Select an exercise for this slot before saving duration.",
        params: null,
      };
    }
    const sorted =
      ex.sequences?.length > 0
        ? [...ex.sequences].sort(
            (a, b) => (a.sequence_order || 0) - (b.sequence_order || 0)
          )
        : [];
    let finalDuration = String(ex.te_duration ?? "").trim();
    if (sorted.length > 0) {
      const seqSum = sorted.reduce(
        (acc, seq) => acc + parseDurationMinutes(seq?.sequence_duration),
        0
      );
      finalDuration = formatMinutesForStorage(seqSum);
    }
    const durNum = parseDurationMinutes(finalDuration);
    if (!finalDuration || !(durNum > 0)) {
      return { error: t("durationRequired") || "Duration is required", params: null };
    }
    const params = {
      te_id: ex.te_id,
      ts_id: selectedSession.ts_id,
      ex_id: ex.ex_id,
      te_duration: finalDuration,
    };
    if (sorted.length > 0) {
      params.sequences = sorted.map((seq, idx) => ({
        tes_id: seq.tes_id,
        sequence_duration: seq.sequence_duration ?? "",
        sub_type_id: seq.sub_type_id ?? null,
        sequence_order: seq.sequence_order ?? idx + 1,
        player_a_role: seq.player_a_role || "active",
        player_b_role: seq.player_b_role || "sparring",
        player_a_id: seq.player_a_id ?? null,
        player_b_id: seq.player_b_id ?? null,
      }));
    }
    return { error: null, params };
  };

  const getModifiedPlanningExercises = useCallback(() => {
    if (planningDurationBaseline == null) return [];
    let baseArr;
    try {
      baseArr = JSON.parse(planningDurationBaseline);
    } catch {
      return [];
    }
    const curArr = JSON.parse(buildPlanningDurationSnapshot(list));
    const modified = [];
    for (const c of curArr) {
      const b = baseArr.find((x) => x.te_id === c.te_id);
      const changed = !b || JSON.stringify(c) !== JSON.stringify(b);
      if (!changed) continue;
      const slot = list.find((l) => String(l.te_id) === c.te_id);
      if (slot?.ex_id) modified.push(slot);
    }
    return modified;
  }, [list, planningDurationBaseline]);

  const getCoachExerciseControlTargetIndex = useCallback(() => {
    return pickCoachControlTargetIndex(list, exerciseStates);
  }, [list, exerciseStates]);

  useEffect(() => {
    if (!onCoachExerciseControlContext) return;
    onCoachExerciseControlContext({
      useContinueLabel: shouldUseContinueControlLabel(
        selectedSession,
        list,
        exerciseStates
      ),
    });
  }, [
    onCoachExerciseControlContext,
    selectedSession,
    list,
    exerciseStates,
  ]);

  useEffect(() => {
    if (!onKotStartRoundContext || !canEditPlanning) {
      if (onKotStartRoundContext) onKotStartRoundContext(null);
      return;
    }
    const runningKot = list?.find((ex) => {
      if (!ex?.te_id || !isKotExercise(ex)) return false;
      const sid =
        exerciseStates[ex.te_id] ??
        ex.te_state?.st_id ??
        (typeof ex.te_state === "string" ? ex.te_state : null);
      return sid === TE_STATE_STARTED;
    });
    onKotStartRoundContext(
      runningKot
        ? {
            teId: runningKot.te_id,
            exerciseStateId:
              exerciseStates[runningKot.te_id] ??
              runningKot.te_state?.st_id ??
              runningKot.te_state,
          }
        : null
    );
  }, [onKotStartRoundContext, list, exerciseStates, canEditPlanning]);

  const applyModifiedPlanningDurations = useCallback(async () => {
    if (!canEditPlanning || !selectedSession?.ts_id) return { saved: 0 };
    const modified = getModifiedPlanningExercises();
    if (modified.length === 0) return { saved: 0 };
    seterror(null);
    const exercisesPayload = [];
    for (const ex of modified) {
      const { error: paramError, params } = buildEditExerciseParamsFromPlanningCard(ex);
      if (paramError) {
        seterror(paramError);
        throw new Error(paramError);
      }
      exercisesPayload.push(params);
    }
    const response = await applyPlanningExerciseBatch({
      ts_id: selectedSession.ts_id,
      exercises: exercisesPayload,
      allow_duration_exceed: true,
    });
    const lastMessage = response?.data?.message;
    setsuccess(lastMessage || t("saved") || "Saved");
    setopen(true);
    setshowoption(false);
    await getexlist(selectedSession.ts_id);
    setTimeout(() => setopen(false), 2000);
    return { saved: modified.length };
  }, [canEditPlanning, selectedSession?.ts_id, getModifiedPlanningExercises, t]);

  useImperativeHandle(
    ref,
    () => ({
      applyModifiedPlanningDurations,
      getCoachExerciseControlTargetIndex,
    }),
    [applyModifiedPlanningDurations, getCoachExerciseControlTargetIndex]
  );

  const swapBoxes = async (fromBox, toBox) => {
    const newBoxes = [...list];
    const fromIndex = newBoxes.findIndex((box) => box.te_id === fromBox.te_id);
    const toIndex = newBoxes.findIndex((box) => box.te_id === toBox.te_id);
    if (fromIndex !== -1 && toIndex !== -1) {
      try {
        const params = {
          target_te_id: newBoxes[fromIndex].te_id,
          target_ts_id: selectedSession.ts_id,
          target_te_order: newBoxes[fromIndex].te_order,
          replace_te_id: newBoxes[toIndex].te_id,
          replace_ts_id: selectedSession.ts_id,
          replace_te_order: newBoxes[toIndex].te_order,
        };

        const response = await exerciseswap(params);
        getexlist(selectedSession.ts_id);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const moveExerciseStep = async (exercise, delta) => {
    // Planning reorder: coaches/admins (type 1–3); players (type 4) read-only
    if (!canEditPlanning) return;
    const st = exercise.tbl_state_te?.st_id || exercise.te_state;
    if (st === TE_STATE_FINALIZED || st === TE_STATE_CANCELLED) return;
    const ordered = [...planningVisibleList].sort((a, b) => (a.te_order ?? 0) - (b.te_order ?? 0));
    const idx = ordered.findIndex((e) => String(e.te_id) === String(exercise.te_id));
    const j = idx + delta;
    if (idx < 0 || j < 0 || j >= ordered.length) return;
    await swapBoxes(ordered[idx], ordered[j]);
  };

  const handleDragStart = useCallback(
    (data) => (event) => {
      event.dataTransfer.setData("dragContent", JSON.stringify(data));
    },
    []
  );

  const handleDragOver = useCallback((event) => {
    event.preventDefault();
  }, []);

  const handleDrop = useCallback(
    (data) => (event) => {
      event.preventDefault();
      const fromBox = event.dataTransfer.getData("dragContent");
      const toBox = data;
      swapBoxes(JSON.parse(fromBox), toBox);
    },
    [list]
  );

  // Mobile touch handlers for exercise drag and drop
  const handleExerciseTouchStart = (exercise, event) => {
    if (!canEditPlanning) return;
    const st = exercise.tbl_state_te?.st_id || exercise.te_state;
    if (st === TE_STATE_FINALIZED || st === TE_STATE_CANCELLED) return;
    
    if (event.type === 'touchstart' || event.touches) {
      const touch = event.touches ? event.touches[0] : null;
      if (!touch) return;
      
      const startX = touch.clientX;
      const startY = touch.clientY;
      
      // Store touch start info for later comparison
      const touchStartInfo = {
        exercise,
        startX,
        startY,
        startTime: Date.now(),
      };
      
      // Start press-hold timer for mobile
      const timer = setTimeout(() => {
        setIsDraggingExercise(true);
        setDraggedExerciseId(exercise.te_id);
        setExerciseDragOccurred(false); // Reset drag flag
        // Add haptic feedback if available
        if (navigator.vibrate) {
          navigator.vibrate(50);
        }
      }, 400); // 400ms press-hold delay for better UX
      setExercisePressHoldTimer(timer);
      
      // Store touch start info on the element for touch move/end handlers
      event.currentTarget._touchStartInfo = touchStartInfo;
    }
  };

  const handleExerciseTouchMove = (event) => {
    if (exercisePressHoldTimer) {
      // Cancel press-hold if user moves finger significantly before timer completes
      const touch = event.touches[0];
      const element = event.currentTarget;
      const touchStartInfo = element._touchStartInfo;
      
      if (touchStartInfo && touch) {
        const deltaX = Math.abs(touch.clientX - touchStartInfo.startX);
        const deltaY = Math.abs(touch.clientY - touchStartInfo.startY);
        
        // If moved more than 10px, cancel the press-hold timer (user is scrolling, not dragging)
        if (deltaX > 10 || deltaY > 10) {
          clearTimeout(exercisePressHoldTimer);
          setExercisePressHoldTimer(null);
        }
      }
    }
    
    if (isDraggingExercise && draggedExerciseId) {
      event.preventDefault();
      setExerciseDragOccurred(true); // Mark that a drag is occurring
      // Find which exercise we're over
      const touch = event.touches[0];
      const elementBelow = document.elementFromPoint(touch.clientX, touch.clientY);
      const exerciseBox = elementBelow?.closest('[data-exercise-box]');
      if (exerciseBox) {
        const teId = exerciseBox.getAttribute('data-te-id');
        // Convert to string for consistent comparison
        const teIdStr = String(teId);
        const draggedIdStr = String(draggedExerciseId);
        if (teId && teIdStr !== draggedIdStr) {
          setDragOverExerciseId(teId);
        }
      }
    }
  };

  const handleExerciseTouchEnd = (event) => {
    // Clear press-hold timer on touch end
    if (exercisePressHoldTimer) {
      clearTimeout(exercisePressHoldTimer);
      setExercisePressHoldTimer(null);
    }
    
    // Clean up touch start info
    if (event.currentTarget) {
      delete event.currentTarget._touchStartInfo;
    }
    
    if (isDraggingExercise && draggedExerciseId && dragOverExerciseId && draggedExerciseId !== dragOverExerciseId) {
      // Find the exercises in the list
      const fromExercise = list.find(ex => String(ex.te_id) === String(draggedExerciseId));
      const toExercise = list.find(ex => String(ex.te_id) === String(dragOverExerciseId));
      
      if (fromExercise && toExercise) {
        // Swap the exercises
        swapBoxes(fromExercise, toExercise);
      }
    }
    
    // Use a small timeout to prevent click from firing immediately after drag
    if (exerciseDragOccurred) {
      setTimeout(() => {
        setExerciseDragOccurred(false);
      }, 100);
    }
    
    setIsDraggingExercise(false);
    setDraggedExerciseId(null);
    setDragOverExerciseId(null);
  };

  const handleUseTemplateClick = async (tsgId, teId) => {
    try {
      setLoadingTemplate(true);
      const targetTsg = tsgId || templateTargetTsgId || selectedTsgId;
      if (targetTsg) {
        setTemplateTargetTsgId(targetTsg);
        templateTargetTsgIdRef.current = targetTsg;
      }
      templateTargetTeIdRef.current = teId || null;
      const params = {};
      if (user?.coach_id) params.coach_id = user.coach_id;
      if (user?.club_id) params.club_id = user.club_id;
      const response = await getTrainingSessionTemplates(params);
      setTemplates(response.data.data || []);
      setTemplateDialogOpen(true);
    } catch (error) {
      console.error("Error loading templates:", error);
      seterror(error.message || t("errorLoadingTemplates") || "Error loading templates");
    } finally {
      setLoadingTemplate(false);
    }
  };

  const handleApplyTemplate = async () => {
    if (!selectedTemplate) {
      seterror(t("pleaseSelectTemplate") || "Please select a template");
      return;
    }
    const grId = selectedSession.gr_id || selectedgrp?.groupDetails?.gr_id;
    if (!grId) {
      seterror(t("selectSessionAndGroup") || "Please select a session and group");
      return;
    }
    setTemplateDialogOpen(false);
    setTemplateApplyWizardOpen(true);
  };

  const doApplyTemplate = async (grId, cbSlotChoices, { typesOnly = false, levelContext = null } = {}) => {
    try {
      setLoadingTemplate(true);
      const body = {
        tst_id: selectedTemplate.tst_id,
        ts_id: selectedSession.ts_id,
        gr_id: grId,
        tsg_id: templateTargetTsgIdRef.current || templateTargetTsgId || selectedTsgId || undefined,
        te_id: templateTargetTeIdRef.current || undefined,
      };
      // Layout templates expand stations from tst_meta (unless coach is filling one lane only)
      if (String(selectedTemplate.tst_kind || "").toLowerCase() === "layout") {
        body.expand_layout = true;
        // Primary lane is created as station 0; ignore a stale station target
        delete body.tsg_id;
      }
      if (typesOnly) {
        body.apply_types_only = true;
      } else if (cbSlotChoices && cbSlotChoices.length > 0) {
        body.cb_slot_choices = cbSlotChoices;
      }
      if (levelContext) body.level_context = levelContext;
      const response = await applyTrainingSessionTemplate(body);
      const data = response.data;
      if (data.status === "success") {
        const stationsN = data.data?.stations?.length || 0;
        const baseMsg =
          data.message || t("templateApplied") || "Template applied successfully";
        // Backend already appends station note when layout expands; only add if missing
        const needsLayoutNote =
          data.data?.layoutExpanded &&
          stationsN > 1 &&
          !/station/i.test(String(baseMsg));
        const layoutMsg = needsLayoutNote
          ? ` · ${t("layoutStationsReady", "{{n}} stations ready", { n: stationsN })}`
          : "";
        setsuccess(`${baseMsg}${layoutMsg}`);
        setopen(true);
        setTemplateDialogOpen(false);
        setTemplateApplyWizardOpen(false);
        setSelectedTemplate(null);
        setTemplateTargetTsgId(null);
        getexlist(selectedSession.ts_id);
        loadSubgroups(selectedSession.ts_id);
        setTimeout(() => setopen(false), 2000);
      } else {
        seterror(data.message || t("errorApplyingTemplate") || "Error applying template");
      }
    } catch (error) {
      console.error("Error applying template:", error);
      const errMsg = error?.message || error?.data?.message || t("errorApplyingTemplate") || "Error applying template";
      const errPayload = error?.data;
      const reasons = errPayload?.reasons;
      if (Array.isArray(reasons) && reasons.length > 0) {
        seterror(`${errMsg}: ${reasons.join("; ")}`);
      } else if (errPayload && typeof errPayload === "object") {
        seterror(`${errMsg}: ${JSON.stringify(errPayload)}`);
      } else {
        seterror(errMsg);
      }
    } finally {
      setLoadingTemplate(false);
    }
  };

  const handleAIRecommendClick = () => {
    if (!hasSessionAndGroup(selectedSession, selectedgrp)) {
      seterror(t("selectSessionAndGroup") || "Please select a session and group");
      return;
    }
    setAiRecommendChoiceDialogOpen(true);
  };

  const handleStructuredSessionClick = () => {
    if (!hasSessionAndGroup(selectedSession, selectedgrp)) {
      seterror(t("selectSessionAndGroup") || "Please select a session and group");
      return;
    }
    setStructuredSessionDialogOpen(true);
  };

  const handleGetAIRecommendations = async () => {
    setAiRecommendChoiceDialogOpen(false);
    const grId = resolveSessionGroupId(selectedSession, selectedgrp);
    if (!selectedSession?.ts_id || !grId) {
      seterror(t("selectSessionAndGroup") || "Please select a session and group");
      return;
    }
    try {
      setLoadingRecommend(true);
      setRecommendedExercises([]);
      setSelectedRecommendExercise(null);
      setRecommendDialogOpen(true);
      const response = await axios.post(
        `${ip_back}api/exercises/recommend-for-session`,
        {
          ts_id: selectedSession.ts_id,
          gr_id: grId,
          language: currentlng,
          session_type: recommendationSessionType,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (response.data.status === "success" && response.data.data?.exercises) {
        setRecommendedExercises(response.data.data.exercises);
      } else {
        seterror(response.data.message || t("noRecommendations") || "No recommendations available");
      }
    } catch (err) {
      console.error("Error fetching AI recommendations:", err);
      seterror(err.response?.data?.message || err.message || t("errorLoadingRecommendations") || "Error loading recommendations");
    } finally {
      setLoadingRecommend(false);
    }
  };

  const handleGetSessionPlanRecommendation = async (options = {}) => {
    const opts = options?.nativeEvent ? {} : options;
    if (opts.closeChoiceDialog !== false) setAiRecommendChoiceDialogOpen(false);
    if (opts.closeStructuredDialog) setStructuredSessionDialogOpen(false);
    const grId = resolveSessionGroupId(selectedSession, selectedgrp);
    if (!selectedSession?.ts_id || !grId) {
      seterror(t("selectSessionAndGroup") || "Please select a session and group");
      return;
    }
    try {
      setLoadingSessionPlan(true);
      setGeneratedSessionPlan(null);
      setSessionPlanDialogOpen(true);
      const targetDuration = opts.targetDuration || selectedSession?.ts_duration || 60;
      const body = {
        ts_id: selectedSession.ts_id,
        gr_id: grId,
        target_duration: targetDuration,
        language: currentlng,
      };
      if (opts.structuredSession) {
        body.structured_session = true;
        body.plan_type = "goal_based_90";
        body.include_stretching = opts.includeStretching === true;
      }
      const response = await axios.post(
        `${ip_back}api/exercises/recommend-session-plan`,
        body,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (response.data.status === "success" && response.data.data?.generated_session) {
        const data = response.data.data;
        // Enrich each exercise with full details (type, subtype, themes, skills, cb_details, etc.) so ExerciseCard renders properly
        if (data.generated_session?.items?.length) {
          await Promise.all(
            data.generated_session.items.map(async (item) => {
              if (!item.recommended_exercises?.length) return;
              item.recommended_exercises = await Promise.all(
                item.recommended_exercises.map(async (ex) => {
                  try {
                    const { data: resData } = await exdetails({ ex_id: ex.ex_id });
                    const full = resData?.data;
                    if (full) {
                      return { ...full, ex_id: ex.ex_id, duration: parseInt(ex.duration, 10) || parseInt(full.te_duration, 10) || 10 };
                    }
                  } catch { /* keep minimal data */ }
                  return { ...ex, duration: parseInt(ex.duration, 10) || 10 };
                })
              );
            })
          );
        }
        setGeneratedSessionPlan(data);
        if (data.generated_session?.items?.length) {
          const initial = {};
          data.generated_session.items.forEach((item, idx) => {
            const first = item.recommended_exercises?.[0];
            if (first?.ex_id) {
              const itemIndex = item.itemIndex !== undefined ? Number(item.itemIndex) : idx;
              initial[itemIndex] = first.ex_id;
              initial[idx] = first.ex_id;
            }
          });
          setSessionPlanSlotSelections(initial);
        } else {
          setSessionPlanSlotSelections({});
        }
      } else {
        seterror(response.data.message || t("noRecommendations") || "No session plan available");
      }
    } catch (err) {
      console.error("Error fetching session plan:", err);
      seterror(err.response?.data?.message || err.message || t("errorLoadingRecommendations") || "Error loading recommendations");
    } finally {
      setLoadingSessionPlan(false);
    }
  };

  const handleGenerateStructuredSession = () => {
    handleGetSessionPlanRecommendation({
      structuredSession: true,
      targetDuration: 90,
      includeStretching: includeStretchingAddon,
      closeChoiceDialog: false,
      closeStructuredDialog: true,
    });
  };

  const handleApplySessionPlan = async () => {
    const grId = resolveSessionGroupId(selectedSession, selectedgrp);
    if (!generatedSessionPlan?.generated_session?.items || !selectedSession?.ts_id || !grId) return;
    const items = generatedSessionPlan.generated_session.items;

    if (generatedSessionPlan.selected_template) {
      const slot_choices = items
        .map((item, idx) => {
          const itemIndex = item.itemIndex !== undefined ? Number(item.itemIndex) : idx;
          const exId = sessionPlanSlotSelections[itemIndex] ?? sessionPlanSlotSelections[idx];
          const rec = item.recommended_exercises?.find((r) => r.ex_id === exId);
          const duration =
            parseInt(rec?.duration, 10) ||
            parseInt(item.duration_minutes, 10) ||
            10;
          return { itemIndex, ex_id: exId, cb_id: rec?.cb_id ?? null, duration };
        })
        .filter((c) => c.ex_id);
      if (slot_choices.length === 0) return;
      try {
        setLoadingSessionPlan(true);
        await applyTrainingSessionTemplate({
          tst_id: generatedSessionPlan.selected_template.tst_id,
          ts_id: selectedSession.ts_id,
          gr_id: grId,
          slot_choices,
          expand_layout:
            String(generatedSessionPlan.selected_template.tst_kind || "").toLowerCase() ===
            "layout"
              ? true
              : undefined,
        });
        setsuccess(t("templateApplied") || "Session plan applied successfully");
        setopen(true);
        setSessionPlanDialogOpen(false);
        setGeneratedSessionPlan(null);
        setSessionPlanSlotSelections({});
        getexlist(selectedSession.ts_id);
        loadSubgroups(selectedSession.ts_id);
        setTimeout(() => setopen(false), 2000);
      } catch (err) {
        seterror(err?.message || t("errorApplyingTemplate") || "Error applying session plan");
      } finally {
        setLoadingSessionPlan(false);
      }
      return;
    }

    const exIds = items
      .filter((item) => item.recommended_exercises?.length > 0)
      .map((item, idx) => {
        const itemIndex = item.itemIndex !== undefined ? Number(item.itemIndex) : idx;
        const selectedExId = sessionPlanSlotSelections[itemIndex] ?? sessionPlanSlotSelections[idx];
        const top =
          item.recommended_exercises.find((r) => r.ex_id === selectedExId) ||
          item.recommended_exercises[0];
        return {
          ex_id: top.ex_id,
          duration: parseInt(item.duration_minutes, 10) || parseInt(top.duration, 10) || 5,
          steps: 1,
        };
      });
    if (exIds.length === 0) return;
    try {
      setLoadingSessionPlan(true);
      await addexercise({
        ts_id: selectedSession.ts_id,
        ex_ids: exIds,
        allow_duration_exceed: true,
        tsg_id: selectedTsgId || undefined,
      });
      setsuccess(t("templateApplied") || "Session plan applied successfully");
      setopen(true);
      setSessionPlanDialogOpen(false);
      setGeneratedSessionPlan(null);
      getexlist(selectedSession.ts_id);
      setTimeout(() => setopen(false), 2000);
    } catch (err) {
      seterror(err?.message || t("errorApplyingTemplate") || "Error applying session plan");
    } finally {
      setLoadingSessionPlan(false);
    }
  };

  const handleSelectRecommendedExercise = async (ex) => {
    if (!ex?.ex_id || !selectedSession?.ts_id) return;
    try {
      setLoadingRecommend(true);
      const duration = parseInt(ex.duration, 10) || 5;
      await addexercise({
        ts_id: selectedSession.ts_id,
        ex_ids: [{ ex_id: ex.ex_id, duration, steps: 1 }],
        allow_duration_exceed: true,
        tsg_id: selectedTsgId || undefined,
      });
      setsuccess(t("exerciseAdded") || "Exercise added successfully");
      setopen(true);
      setRecommendDialogOpen(false);
      setRecommendedExercises([]);
      setSelectedRecommendExercise(null);
      getexlist(selectedSession.ts_id);
      setTimeout(() => setopen(false), 2000);
    } catch (err) {
      seterror(err?.message || t("errorAddingExercise") || "Error adding exercise");
    } finally {
      setLoadingRecommend(false);
    }
  };

  const openSplitDialog = async () => {
    setSplitDialogOpen(true);
    const grId = resolveSessionGroupId(selectedSession, selectedgrp);
    if (!grId || !selectedSession?.ts_id) return;
    try {
      const tablesRes = await tablelist({
        gr_id: grId,
        ts_id: selectedSession.ts_id,
        te_id: list?.[0]?.te_id || selectedExercise?.te_id,
      });
      const tablesData = tablesRes?.data?.data || [];
      setRoomTables(Array.isArray(tablesData) ? tablesData : []);
    } catch (e) {
      setRoomTables([]);
    }
  };

  const handleCreateSubgroup = async ({ name, timer_mode, table_ids }) => {
    if (!selectedSession?.ts_id) return;
    try {
      setSplitBusy(true);
      const response = await createSessionSubgroup({
        ts_id: selectedSession.ts_id,
        name,
        timer_mode,
        table_ids,
      });
      const created = response?.data?.data?.created;
      const next = response?.data?.data?.subgroups || [];
      setSubgroups(next);
      if (created?.tsg_id) selectPlanningLane(created.tsg_id);
      setSplitDialogOpen(false);
      setsuccess(t("subGroupCreated") || "Station created");
      setopen(true);
      getexlist(selectedSession.ts_id);
      setTimeout(() => setopen(false), 2000);
    } catch (error) {
      seterror(error?.message || t("errorCreatingSubGroup") || "Could not create station");
    } finally {
      setSplitBusy(false);
    }
  };

  const handleRenameSubgroup = async (tsgId, name) => {
    if (!tsgId || !name?.trim()) return;
    try {
      const response = await updateSessionSubgroup(tsgId, { name: name.trim() });
      setSubgroups(response?.data?.data?.subgroups || subgroups);
    } catch (error) {
      seterror(error?.message || t("errorUpdatingSubGroup") || "Could not rename station");
    }
  };

  const handleToggleTimer = async (tsgId, timer_mode) => {
    try {
      const response = await updateSessionSubgroup(tsgId, { timer_mode });
      setSubgroups(response?.data?.data?.subgroups || subgroups);
      if (selectedSession?.ts_id) getexlist(selectedSession.ts_id);
    } catch (error) {
      seterror(error?.message || t("errorUpdatingSubGroup") || "Could not update timer");
    }
  };

  const handleDeleteSubgroup = async (tsgId) => {
    try {
      const response = await deleteSessionSubgroup(tsgId);
      const next = response?.data?.data || [];
      setSubgroups(next);
      const main = next.find((s) => s.is_main) || next[0];
      selectPlanningLane(main?.tsg_id || null);
      getexlist(selectedSession.ts_id);
    } catch (error) {
      seterror(error?.message || t("errorDeletingSubGroup") || "Could not remove station");
    }
  };

  const handleAddExerciseClick = (teId) => {
    console.log("🖱️ Exercises - Card clicked!");
    // Try to get mode from association first, then fallback to direct field
    const trainingMode = selectedgrp?.groupDetails?.tbl_gen_mode_t || selectedgrp?.groupDetails?.tbl_gen_mode_ts;
    const modeIdFromAssociation = trainingMode?.te_gen_mode_id;
    const modeNameFromAssociation = trainingMode?.ts_gen_mode;
    // Also check direct field in case association is not loaded
    const modeIdFromField = selectedgrp?.groupDetails?.gr_traning_session_type;
    
    // Use association if available, otherwise use direct field
    const modeId = modeIdFromAssociation || modeIdFromField;
    const modeName = modeNameFromAssociation;
    
    console.log("🔍 Exercises - Training mode check:", {
      trainingMode,
      modeIdFromAssociation,
      modeIdFromField,
      modeId,
      modeName,
      gr_traning_session_type: selectedgrp?.groupDetails?.gr_traning_session_type,
      selectedgrp: selectedgrp?.groupDetails,
      sessionId: selectedSession?.ts_id
    });
    
    // Allow exercise addition for Manual, Wizard, and Seasonal modes
    // Manual: tsgm2024091410200912
    // Wizard: tsgm2024091410200913
    // Seasonal: tsgm2024091410200915
    // Also check by mode name in case ID is different
    // Fallback: when mode is null/undefined (group not configured), treat as Manual to allow adding exercises
    const isManual = modeId === "tsgm2024091410200912" || modeName === "Manual" || (modeId == null && modeName == null);
    const isWizard = modeId === "tsgm2024091410200913" || modeName === "Wizard";
    const isSeasonal = modeId === "tsgm2024091410200915" || modeName === "Seasonal";
    
    if (isManual || isWizard || isSeasonal) {
      const grId = resolveSessionGroupId(selectedSession, selectedgrp);
      if (!selectedSession?.ts_id || !grId) {
        seterror(t("selectSessionAndGroup") || "Please select a session and group");
        return;
      }
      console.log("✅ Exercise addition allowed for mode:", modeName || modeId || "(defaulting to Manual)");
      const block = teId
        ? (list || []).find((ex) => String(ex.te_id) === String(teId))
        : null;
      const nav = addExerciseNavigation(block, {
        sessionid: selectedSession.ts_id,
        grpid: grId,
        tsg_id: selectedTsgId || readPlanningTsgId() || undefined,
        te_id: teId || undefined,
        lng: currentlng,
      });
      navigate(nav.path, { state: nav.state });
    } else {
      console.warn("⚠️ Cannot add exercises: Training mode not supported for exercise addition");
      console.warn("   Mode ID from association:", modeIdFromAssociation);
      console.warn("   Mode ID from field:", modeIdFromField);
      console.warn("   Final Mode ID:", modeId);
      console.warn("   Mode Name:", modeName);
      console.warn("   Supported modes: Manual, Wizard, Seasonal");
      console.warn("   Supported IDs: tsgm2024091410200912, tsgm2024091410200913, tsgm2024091410200915");
    }
  };

  useEffect(() => {
    if (!editDialogOpen || !pendingAddSequenceRef.current) return undefined;
    pendingAddSequenceRef.current = false;
    const timer = window.setTimeout(() => {
      handleAddSequence();
    }, 60);
    return () => window.clearTimeout(timer);
  }, [editDialogOpen]); // eslint-disable-line react-hooks/exhaustive-deps

  const handlePlanningVoiceCommand = async (cmd) => {
      const planLocked =
        selectedSession?.tbl_state_te?.st_id === "st202406071447279903" &&
        !canManagePastSessions;
      if (!cmd?.type || !canEditPlanning || planLocked) return false;
      const focusEx =
        cmd.exercise ||
        selectedExercise ||
        detailsExercise ||
        editingExercise ||
        null;
      const laneTsg =
        focusEx?.tsg_id || selectedTsgId || readPlanningTsgId() || null;
      const grId = resolveSessionGroupId(selectedSession, selectedgrp);

      if (cmd.type === "add_exercise") {
        if (laneTsg) selectPlanningLane(laneTsg);
        handleAddExerciseClick(focusEx?.te_id || null);
        return true;
      }

      if (cmd.type === "edit_exercise") {
        if (!focusEx?.te_id) return false;
        if (laneTsg) selectPlanningLane(laneTsg);
        setSelectedExercise(focusEx);
        await handleOpenEditDialog(focusEx);
        return true;
      }

      if (cmd.type === "add_sequence") {
        if (!focusEx?.te_id) return false;
        if (laneTsg) selectPlanningLane(laneTsg);
        setSelectedExercise(focusEx);
        pendingAddSequenceRef.current = true;
        await handleOpenEditDialog(focusEx);
        return true;
      }

      if (cmd.type === "apply_template") {
        if (laneTsg) {
          selectPlanningLane(laneTsg);
          templateTargetTsgIdRef.current = laneTsg;
          setTemplateTargetTsgId(laneTsg);
        }
        await handleUseTemplateClick(laneTsg, focusEx?.te_id || null);
        return true;
      }

      if (cmd.type === "create_personalized") {
        if (!selectedSession?.ts_id || !grId) return false;
        if (laneTsg) selectPlanningLane(laneTsg);
        navigate("/PersonalizedTrainingSlot", {
          state: {
            sessionid: selectedSession.ts_id,
            grpid: grId,
            tsg_id: laneTsg || undefined,
            te_id: focusEx?.te_id || undefined,
            voice_description: cmd.description || "",
          },
        });
        return true;
      }

      if (cmd.type === "create_custom") {
        if (!selectedSession?.ts_id || !grId) return false;
        if (laneTsg) selectPlanningLane(laneTsg);
        navigate("/SelectExerciseType", {
          state: {
            sessionid: selectedSession.ts_id,
            grpid: grId,
            tsg_id: laneTsg || undefined,
            te_id: focusEx?.te_id || undefined,
            voice_description: cmd.description || "",
            voice_prompt: cmd.description || "",
          },
        });
        return true;
      }

      if (cmd.type === "select_catalog") {
        if (!focusEx?.te_id) {
          if (!selectedSession?.ts_id || !grId) return false;
          navigate("/SelectExerciseType", {
            state: {
              sessionid: selectedSession.ts_id,
              grpid: grId,
              tsg_id: laneTsg || undefined,
              voice_query: cmd.query || "",
              voice_prompt: cmd.query || "",
            },
          });
          return true;
        }
        if (laneTsg) selectPlanningLane(laneTsg);
        setSelectedExercise(focusEx);
        setExchangeInitialQuery(cmd.query || "");
        await handleOpenEditDialog(focusEx);
        setExchangeDialogOpen(true);
        return true;
      }

      if (cmd.type === "create_station") {
        await openSplitDialog();
        return true;
      }

      if (cmd.type === "ai_action") {
        requestPlanningRefresh();
        return true;
      }

      return null;
  };
  console.log("selectedsession", selectedSession);

  // Debug: Check why "Add Exercise" button might not be visible
  const sessionStateId = selectedSession?.tbl_state_te?.st_id;
  const isSessionCompleted = sessionStateId === "st202406071447279903";
  const sessionPlanLocked = isSessionCompleted && !canManagePastSessions;
  const hasAddExercisePermission = hasPermission("ADD_EXERCISE");
  const canShowAddButton =
    canEditPlanning &&
    selectedSession &&
    !sessionPlanLocked &&
    hasAddExercisePermission;
  
  console.log("🔍 Exercises - Button visibility check:", {
    hasSelectedSession: !!selectedSession,
    sessionStateId,
    isSessionCompleted,
    canManagePastSessions,
    hasAddExercisePermission,
    canShowAddButton,
    selectedSessionState: selectedSession?.tbl_state_te,
    userPermissions: JSON.parse(localStorage.getItem("userPermissions") || "[]")
  });

  return (
    <>
      {selectedSession ? (
        <>
          {sessionExerciseListLoading ? (
            <LinearProgress
              aria-label={t("loading") || "Loading"}
              sx={{
                width: "100%",
                maxWidth: "100%",
                mb: 0.5,
                borderRadius: 1,
                height: 4,
                bgcolor: "rgba(0,0,0,0.08)",
                "& .MuiLinearProgress-bar": {
                  borderRadius: 1,
                  bgcolor: "var(--brand-primary, #0877BC)",
                },
              }}
            />
          ) : null}
          <PlanningSubgroupBoard
            lanes={planningLanes}
            selectedTsgId={selectedTsgId}
            selectedTeId={selectedExercise?.te_id}
            sessionDuration={selectedSession?.ts_duration}
            canEdit={canEditPlanning && !sessionPlanLocked}
            highlightActions={tourDemo}
            onSelectLane={selectPlanningLane}
            onSelectExercise={handleex}
            onSplit={openSplitDialog}
            onRename={handleRenameSubgroup}
            onToggleTimer={handleToggleTimer}
            onDelete={handleDeleteSubgroup}
            onApplyTemplate={(tsgId, teId) => {
              templateTargetTsgIdRef.current = tsgId;
              setTemplateTargetTsgId(tsgId);
              handleUseTemplateClick(tsgId, teId);
            }}
            onAddExercise={(tsgId, teId) => {
              selectPlanningLane(tsgId);
              handleAddExerciseClick(teId);
            }}
            onOpenDetails={(ex, lane) => {
              setSelectedExercise(ex);
              if (lane?.tsg_id) selectPlanningLane(lane.tsg_id);
              setDetailsExercise(ex);
            }}
            onEditExercise={(ex, lane) => {
              if (lane?.tsg_id) selectPlanningLane(lane.tsg_id);
              setSelectedExercise(ex);
              handleOpenEditDialog(ex);
            }}
            onSwapBlocks={handleSwapTrainingBlocks}
            swapSourceTeId={swapSource?.te_id || null}
            onStartSwap={(ex) => {
              setSwapSource(ex);
              setSelectedExercise(ex);
            }}
            onCancelSwap={() => setSwapSource(null)}
            swapBusy={swapBusy}
            onSyncBlock={(ex) => {
              setSelectedExercise(ex);
              setSyncBlockSource(ex);
              setSwapSource(null);
            }}
            onDeleteBlock={(ex) => {
              setSelectedExercise(ex);
              handleOpenDeleteDialog(ex);
            }}
            lockedTeIds={lockedPlanningTeIds}
            teStateById={exerciseStates}
            competencyBlocks={competencyBlocks}
            onLoadCompetencyBlocks={fetchCompetencyBlocks}
            onChangeCompetencyBlock={(ex, cbId, lane) => {
              if (lane?.tsg_id) selectPlanningLane(lane.tsg_id);
              handleQuickCompetencyBlockChange(ex, cbId);
            }}
            competencyBlockBusy={quickCbBusy}
            pingfloSlot={
              canEditPlanning && !sessionPlanLocked && selectedSession?.ts_id ? (
                <PlanningPingfloVoice
                  disabled={!canEditPlanning || sessionPlanLocked}
                  tsId={selectedSession.ts_id}
                  grId={resolveSessionGroupId(selectedSession, selectedgrp)}
                  primaryColor={brandPrimary}
                  exercises={list}
                  selectedExercise={selectedExercise || detailsExercise}
                  selectedTsgId={selectedTsgId}
                  stationName={
                    planningLanes.find(
                      (l) => String(l.tsg_id) === String(selectedTsgId)
                    )?.name || null
                  }
                  onVoiceCommand={handlePlanningVoiceCommand}
                />
              ) : null
            }
          />
          <PlanningExerciseDetailsDialog
            open={Boolean(detailsExercise)}
            exercise={detailsExercise}
            stationName={
              planningLanes.find(
                (l) => String(l.tsg_id) === String(detailsExercise?.tsg_id || selectedTsgId)
              )?.is_main
                ? t("mainGroup") || "Main group"
                : planningLanes.find(
                    (l) =>
                      String(l.tsg_id) ===
                      String(detailsExercise?.tsg_id || selectedTsgId)
                  )?.name
            }
            sessionLabel={
              formatTrainingSessionHash(selectedSession)
                ? `#${formatTrainingSessionHash(selectedSession)}`
                : ""
            }
            canEdit={canEditPlanning && !sessionPlanLocked}
            onClose={() => setDetailsExercise(null)}
            onEdit={(ex) => {
              setDetailsExercise(null);
              handleOpenEditDialog(ex);
            }}
            onSwap={(ex) => {
              setDetailsExercise(null);
              setSwapSource(ex);
              setSelectedExercise(ex);
            }}
            canSyncBlock={planningLanes.length >= 2}
            onSyncBlock={(ex) => {
              setDetailsExercise(null);
              setSelectedExercise(ex);
              setSyncBlockSource(ex);
              setSwapSource(null);
            }}
            onDelete={(ex) => {
              setDetailsExercise(null);
              handleOpenDeleteDialog(ex);
            }}
          />
          <SyncBlockExerciseDialog
            open={Boolean(syncBlockSource)}
            sourceExercise={syncBlockSource}
            lanes={planningLanes}
            busy={syncBlockBusy}
            onClose={() => {
              if (!syncBlockBusy) setSyncBlockSource(null);
            }}
            onConfirm={handleSyncBlockExercise}
          />
          <div
            className="exercise_session_div"
            hidden
            aria-hidden="true"
            aria-busy={sessionExerciseListLoading}
          >
            {selectedTsgId && planningLanes.length > 1 ? (
              <p className="psg-lane-filter" style={{
                margin: "0 0 10px",
                fontSize: 13,
                fontWeight: 650,
                color: "var(--text-secondary)",
              }}>
                {(planningLanes.find((l) => String(l.tsg_id) === String(selectedTsgId))?.is_main
                  ? t("mainGroup")
                  : planningLanes.find((l) => String(l.tsg_id) === String(selectedTsgId))?.name) || t("mainGroup")}
                {" · "}
                {planningVisibleList.length} {t("trainingBlocks") || "training blocks"}
              </p>
            ) : null}
            {planningVisibleList?.filter(i => i != null).map((i, index) => {
              // Use real-time state if available, otherwise fallback to static state
              const realTimeState = exerciseStates[i.te_id];
              const staticStateId = (i && i.te_state && i.te_state.st_id) ? i.te_state.st_id : null;
              const teStateId = realTimeState || staticStateId || (typeof i.te_state === 'string' ? i.te_state : null);
              
              // Check if this exercise is currently running
              const isRunning = teStateId === TE_STATE_STARTED;
              const exerciseTimer = exerciseTimers[i.te_id];
              const currentSequence = currentSequences[i.te_id];
              const sequenceTimer = sequenceTimers[i.te_id];
              
              // Format time helper function
              const formatTime = (seconds) => {
                if (!seconds && seconds !== 0) return "";
                const mins = Math.floor(seconds / 60);
                const secs = seconds % 60;
                return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
              };
              
              const isDraggedExercise = isDraggingExercise && String(draggedExerciseId) === String(i.te_id);
              const isDragOverExercise = isDraggingExercise && String(dragOverExerciseId) === String(i.te_id);
              
              const isSelected = selectedExercise?.te_id === i.te_id;
              const isFinalized = teStateId === TE_STATE_FINALIZED;
              const isCancelled = teStateId === TE_STATE_CANCELLED;
              const stateLabel = getExerciseStateLabel(teStateId, i, t, lngBase);
              const isKotCard = isKotExercise(i);
              const isPersonalizedCard = isPersonalizedTrainingSlot(i);
              const planningKindLabel = isKotCard
                ? t("kingOfTheTable")
                : isPersonalizedCard
                  ? t("personalizedExercise") || "Personalized"
                  : getPlanningExerciseKindLabel(i, currentlng);
              const finalizedSeqCount =
                !isKotCard &&
                !isCancelled &&
                Array.isArray(i.sequences) &&
                i.sequences.length > 0
                  ? i.sequences.length
                  : 0;
              const kotMaxRounds =
                isKotCard && i.kot_config?.max_rounds != null
                  ? i.kot_config.max_rounds
                  : null;
              const canEditPlanRow =
                canEditPlanning &&
                ((!isFinalized && !isCancelled) || canManagePastSessions);
              const canShowDeleteButton =
                role !== 3 && canEditPlanRow && !isRunning;

              return (
              <div
                key={index}
                className={`${
                  isCancelled
                    ? "ex_add_box ex_add_box--cancelled"
                    : isFinalized
                    ? "ex_add_box ex_add_box--finalized"
                    : isRunning
                    ? "ex_add_box ex_add_box--running current-exercise"
                    : isSelected
                    ? "ex_add_box ex_add_box--selected"
                    : "ex_add_box"
                } ${canShowDeleteButton ? "ex_add_box--with-delete" : ""}${
                  isKotCard ? " ex_add_box--kot" : ""
                }${isPersonalizedCard ? " ex_add_box--personalized" : ""}`}
                onClick={(e) => {
                  if (
                    !exerciseDragOccurred &&
                    !e.target.closest(
                      ".ex_add_box__actions, .ex_add_box__duration-input, .ex_add_box__order-wrap, .MuiIconButton-root, .ex_add_box__delete-corner, .kot-settings"
                    )
                  ) {
                    handleex(i);
                  }
                }}
                onDoubleClick={(e) => {
                  if (
                    !e.target.closest(
                      ".ex_add_box__actions, .ex_add_box__duration-input, .ex_add_box__order-wrap, .MuiIconButton-root, .ex_add_box__delete-corner, .kot-settings"
                    )
                  ) {
                    e.stopPropagation();
                    navigate("/Exercisedetail", { state: { id: i.te_id } });
                  }
                }}
                draggable={canEditPlanRow}
                onDragStart={handleDragStart(i)} // Pass the item to be dragged
                onDragOver={handleDragOver} // This ensures the drop target allows dropping
                onDrop={handleDrop(i)}
                onTouchStart={(e) => handleExerciseTouchStart(i, e)}
                onTouchMove={handleExerciseTouchMove}
                onTouchEnd={handleExerciseTouchEnd}
                data-exercise-box="true"
                data-te-id={String(i.te_id)}
                style={{
                  opacity: isDraggingExercise && !isDraggedExercise && draggedExerciseId ? 0.5 : 1,
                  border: isDraggedExercise
                    ? "2px solid var(--brand-primary, #0877BC)"
                    : isDragOverExercise
                    ? "2px dashed var(--brand-primary, #0877BC)"
                    : undefined,
                  backgroundColor: isDraggedExercise ? "#e3f2fd" : isDragOverExercise ? "#f5f5f5" : undefined,
                  touchAction: isDraggingExercise ? "none" : "pan-y", // Allow scrolling when not dragging
                  cursor: isDraggingExercise
                    ? "grabbing"
                    : canEditPlanRow
                    ? "grab"
                    : "pointer",
                }}
              >
                <div className="ex_add_box__main">
                  <div
                    className="ex_add_box__order-wrap"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      minWidth: "40px",
                    }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    {canEditPlanRow ? (
                      <IconButton
                        size="small"
                        aria-label={t("moveUp") || "Move up"}
                        disabled={
                          planningVisibleList.findIndex((e) => String(e.te_id) === String(i.te_id)) <= 0
                        }
                        onClick={() => moveExerciseStep(i, -1)}
                        sx={{
                          padding: "2px",
                          color: "var(--brand-primary, #0877BC)",
                        }}
                      >
                        <ArrowUpwardIcon sx={{ fontSize: 20 }} />
                      </IconButton>
                    ) : null}
                    <div className="ex_add_box__order">{i.te_order}</div>
                    {canEditPlanRow ? (
                      <IconButton
                        size="small"
                        aria-label={t("moveDown") || "Move down"}
                        disabled={
                          (() => {
                            const ix = planningVisibleList.findIndex(
                              (e) => String(e.te_id) === String(i.te_id)
                            );
                            return ix < 0 || ix >= planningVisibleList.length - 1;
                          })()
                        }
                        onClick={() => moveExerciseStep(i, 1)}
                        sx={{
                          padding: "2px",
                          color: "var(--brand-primary, #0877BC)",
                        }}
                      >
                        <ArrowDownwardIcon sx={{ fontSize: 20 }} />
                      </IconButton>
                    ) : null}
                  </div>
                  <div className="ex_add_box__thumb">
                    {i?.sub_type_ex && i?.sub_type_ex?.sub_type_image_normal ? (
                      <img
                        src={
                          teStateId === TE_STATE_STARTED
                            ? (i?.sub_type_ex?.sub_type_image_start ? ip_back + i.sub_type_ex.sub_type_image_start : ip_back + i.sub_type_ex.sub_type_image_normal)
                            : (ip_back + i.sub_type_ex.sub_type_image_normal)
                        }
                        onError={(e) => { e.target.style.display = 'none'; }}
                        alt=""
                      />
                    ) : null}
                    {!i?.sub_type_ex?.sub_type_image_normal && (
                      <svg width="32" height="32" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="ex_add_box__thumb-fallback">
                        <rect x="4" y="8" width="32" height="24" rx="2" fill="var(--brand-primary, #0877BC)" opacity="0.15"/>
                        <path d="M12 16L18 20L12 24V16Z" fill="var(--brand-primary, #0877BC)"/>
                        <rect x="22" y="18" width="10" height="4" rx="1" fill="var(--brand-primary, #0877BC)"/>
                      </svg>
                    )}
                  </div>
                  <div
                    className={`ex_add_box__content${
                      isFinalized ? " ex_add_box__content--finalized" : ""
                    }`}
                  >
                    <div className="ex_add_box__title-row">
                      {isPersonalizedCard ? (
                        <span className="ex_add_box__title">
                          {t("personalizedExercise", "Personalized exercise")}
                        </span>
                      ) : i.ex_name === null ? (
                        hasPermission("SELECT_CB_EXERCISE") ? (
                          <button
                            type="button"
                            className="ex_add_box__select-btn"
                            onClick={(e) => { e.stopPropagation(); navigate("/EditCBExercise", { state: { sessionid: selectedSession.ts_id, grpid: selectedgrp?.groupDetails?.gr_id, teid: i.te_id, duration: i.te_duration, cbid: i.ex_sub_type_id?.cb_id, cb: i.ex_sub_type_id?.[`cb_name_${currentlng}`], exno: i.te_ex_no } }); }}
                          >
                            {t("selectex")} →
                          </button>
                        ) : null
                      ) : (
                        <span className="ex_add_box__title">{localizedExerciseName(i, currentlng) || i.ex_name}</span>
                      )}
                      {!isPersonalizedCard && i.ex_name === null && (i.type_ex || i.sub_type_ex) && (
                        <span className="ex_add_box__subtitle">
                          {i.type_ex?.type_name_en === BLOCKS_OF_COMPETENCY_TYPE_EN
                            ? (() => {
                                const base = currentlng.split("-")[0];
                                const parts = [
                                  localizedCbName(i.competency_block, base),
                                  localizedCbName(i.ex_sub_type_id, base),
                                  localizedSubTypeName(i.sub_type_ex, base),
                                ].filter(Boolean);
                                return [...new Set(parts)].join(" · ");
                              })()
                            : `${i.type_ex?.[`type_name_${currentlng}`] || ""}${i.type_ex && i.sub_type_ex ? " · " : ""}${i.sub_type_ex?.[`sub_type_name_${currentlng}`] || ""}`}
                        </span>
                      )}
                    </div>
                    {isFinalized ? (
                      <div className="ex_add_box__finalized-strip">
                        <div className="ex_add_box__finalized-strip-main">
                          <span className="ex_add_box__duration-readonly">
                            {formatDurationLabel(i.te_duration) || i.te_duration}
                          </span>
                          {planningKindLabel ? (
                            <span
                              className="ex_add_box__kind-chip"
                              title={planningKindLabel}
                            >
                              {planningKindLabel}
                            </span>
                          ) : null}
                          {isKotCard ? (
                            <span
                              className="ex_add_box__kind-chip"
                              title={t("kotRounds")}
                            >
                              {t("kotRounds")}
                              {kotMaxRounds != null ? `: ${kotMaxRounds}` : ""}
                            </span>
                          ) : finalizedSeqCount > 0 ? (
                            <span
                              className="ex_add_box__seq-chip"
                              title={`${finalizedSeqCount} ${t("sequences") || "sequences"}`}
                            >
                              <CheckCircleIcon className="ex_add_box__seq-chip-icon" />
                              <span className="ex_add_box__seq-chip-num">{finalizedSeqCount}</span>
                              <span className="ex_add_box__seq-chip-label">
                                {t("sequencesShort") || "seq."}
                              </span>
                            </span>
                          ) : null}
                        </div>
                        {stateLabel ? (
                          <span
                            className="ex_add_box__status-pill"
                            title={stateLabel}
                          >
                            {stateLabel}
                          </span>
                        ) : null}
                      </div>
                    ) : (
                      <>
                    <div className="ex_add_box__state-row">
                      <span className="ex_add_box__state-text">{stateLabel}</span>
                    </div>
                    <div className="ex_add_box__meta">
                      <span
                        className="ex_add_box__duration"
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          flexWrap: "wrap",
                          gap: "6px",
                        }}
                      >
                        <DurationMinutesSecondsInput
                          value={i.te_duration}
                          onChange={(next) =>
                            handlemin({ target: { value: next } }, i)
                          }
                          readOnly={!canEditPlanRow}
                          inputClassName={
                            canEditPlanRow
                              ? "ex_add_box__duration-input ex_add_box__duration-input--editing"
                              : "ex_add_box__duration-input"
                          }
                        />
                      </span>
                      {planningKindLabel ? (
                        <span
                          className="ex_add_box__type-badge"
                          title={planningKindLabel}
                        >
                          {planningKindLabel}
                        </span>
                      ) : null}
                      {isKotCard ? (
                        <div className="ex_add_box__kot-meta">
                          <span className="ex_add_box__kot-chip">
                            {i.kot_config?.kot_mode === "FULL_SET"
                              ? t("kotModeFullSet")
                              : t("kotModeStopScoreLead")}
                          </span>
                          {kotMaxRounds != null ? (
                            <span className="ex_add_box__kot-chip">
                              {t("kotMaxRounds")} {kotMaxRounds}
                            </span>
                          ) : null}
                        </div>
                      ) : null}
                    </div>
                      </>
                    )}
                    {/* Display current exercise timer if running (not for KoT — card shows elapsed) */}
                    {isRunning &&
                      exerciseTimer !== undefined &&
                      !isKotCard && (
                      <div style={{ 
                        marginTop: "8px", 
                        padding: "6px 10px", 
                        backgroundColor: "#28a745", 
                        color: "#fff",
                        borderRadius: "4px",
                        fontSize: "13px",
                        fontWeight: "600",
                        display: "inline-block"
                      }}>
                        ⏱️ {t("timeRemaining") || "Time Remaining"}: {formatTime(exerciseTimer)}
                      </div>
                    )}
                    
                    {/* Sequences: sequence-based exercises only (never on KoT) */}
                    {!isKotCard &&
                      !isCancelled &&
                      i.sequences &&
                      Array.isArray(i.sequences) &&
                      i.sequences.length > 0 &&
                      !isFinalized &&
                      (
                      <div className="ex_add_box__sequences">
                        <div className="ex_add_box__sequences-title">
                          {t("sequences") || "Sequences"}:
                        </div>
                        {[...(i.sequences || [])]
                          .sort((a, b) => (a.sequence_order || 0) - (b.sequence_order || 0))
                          .map((seq, seqIdx) => {
                          const isCurrentSequence = isRunning && currentSequence && (
                            (currentSequence.tes_id && currentSequence.tes_id === seq.tes_id) ||
                            (currentSequence.sequence_order && currentSequence.sequence_order === seq.sequence_order) ||
                            (currentSequence === seq.sequence_order)
                          );
                          const seqNum = seq.sequence_order != null && seq.sequence_order > 0 ? seq.sequence_order : seqIdx + 1;
                          const baseLng = (currentlng || "en").split("-")[0];
                          const seqBlockName = localizedCbName(seq.competency_block, baseLng);
                          const seqSkillName =
                            seq.sub_type_ex?.[`sub_type_name_${currentlng}`] ||
                            seq.sub_type_name_en ||
                            null;
                          const seqSubType = seqBlockName || seqSkillName || null;
                          
                          return (
                          <div
                            key={seq.tes_id || seqIdx}
                            className={`ex_add_box__seq-item${isCurrentSequence ? " ex_add_box__seq-item--current" : ""}`}
                          >
                            <div className="ex_add_box__seq-item-header">
                              <span className="ex_add_box__seq-item-label">
                                {isCurrentSequence && "▶ "}
                                {seqNum}
                                {seqSubType ? `: ${seqSubType}` : ""}
                                {isCurrentSequence && " (Current)"}
                              </span>
                              <span className="ex_add_box__seq-item-meta">
                                {isCurrentSequence && sequenceTimer !== undefined
                                  ? `⏱️ ${formatTime(sequenceTimer)}`
                                  : canEditPlanRow && i.ex_id
                                  ? (
                                      <DurationMinutesSecondsInput
                                        className="dms-input--compact"
                                        value={seq.sequence_duration ?? ""}
                                        onChange={(next) =>
                                          handleSequenceDurationOnCard(i, seq.tes_id, next)
                                        }
                                      />
                                    )
                                  : formatDurationLabel(seq.sequence_duration) ||
                                    `${seq.sequence_duration} ${t("min") || "min"}`}
                              </span>
                            </div>
                            <div className="ex_add_box__seq-item-roles">
                              <span>
                                <strong>A:</strong> {seq.player_a_role === "active" ? t("performance_role", "Performance") : 
                                                   seq.player_a_role === "sparring" ? t("sparring") || "Sparring" : 
                                                   t("both") || "Both"}
                              </span>
                              <span>
                                <strong>B:</strong> {seq.player_b_role === "active" ? t("performance_role", "Performance") : 
                                                   seq.player_b_role === "sparring" ? t("sparring") || "Sparring" : 
                                                   t("both") || "Both"}
                              </span>
                            </div>
                          </div>
                          );
                        })}
                      </div>
                    )}
                    {/* Display players if they exist (for manually assigned exercises) */}
                    {(!i.sequences || i.sequences.length === 0) && i.players && i.players.length > 0 && (
                      <div className="ex_add_box__player-chips">
                        <div className="ex_add_box__player-chips-row">
                          {i.player1 && (
                            <span className="ex_add_box__player-chip ex_add_box__player-chip--a">
                              <strong>A:</strong> {i.player1.player_name || "Player 1"}
                            </span>
                          )}
                          {i.player2 && (
                            <span className="ex_add_box__player-chip ex_add_box__player-chip--b">
                              <strong>B:</strong> {i.player2.player_name || "Player 2"}
                            </span>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {!canEditPlanning ? (
                  i.ex_name === null ? (
                    <></>
                  ) : (
                    <div className="ex_add_box__finalized-actions">
                      {teStateId === TE_STATE_FINALIZED ||
                      teStateId === TE_STATE_CANCELLED ? (
                        <button
                          type="button"
                          className="ex_add_box__action-btn ex_add_box__action-btn--player-feedback"
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate("/Playerexercise_feedback", {
                              state: {
                                id: i.te_id,
                                selectedSession: selectedSession,
                                selectedgrp: selectedgrp,
                              },
                            });
                          }}
                        >
                          <ChatIcon /> {t("feedback")}
                        </button>
                      ) : null}
                      {(teStateId === TE_STATE_FINALIZED ||
                        teStateId === TE_STATE_STARTED) &&
                      !isKotCard ? (
                        <button
                          type="button"
                          className="ex_add_box__action-btn ex_add_box__action-btn--summary"
                          onClick={(e) => navigateToPlayerSummary(i, e)}
                        >
                          <AssessmentOutlinedIcon />{" "}
                          {t("summary") || "Summary"}
                        </button>
                      ) : null}
                      {teStateId !== TE_STATE_FINALIZED &&
                      teStateId !== TE_STATE_CANCELLED ? (
                        <div className="ex_menu_options ex_add_box__actions">
                          <InfoOutlinedIcon
                            className="exercise_info"
                            onClick={(e) => {
                              e.stopPropagation();
                              navigate("/Exercisedetail", {
                                state: { id: i.te_id },
                              });
                            }}
                          />
                        </div>
                      ) : null}
                    </div>
                  )
                ) : teStateId === TE_STATE_CANCELLED ? (
                  <div className="ex_add_box__finalized-actions">
                    <button
                      type="button"
                      className="ex_add_box__action-btn ex_add_box__action-btn--feedback"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate("/Exercise_feedback", {
                          state: {
                            id: i.te_id,
                            selectedSession: selectedSession,
                            selectedgrp: selectedgrp,
                          },
                        });
                      }}
                    >
                      <ChatIcon /> {t("feedback")}
                    </button>
                  </div>
                ) : teStateId === TE_STATE_FINALIZED ? (
                  <div className="ex_add_box__finalized-actions">
                    <button
                      type="button"
                      className="ex_add_box__action-btn ex_add_box__action-btn--feedback"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate("/Exercise_feedback", {
                          state: {
                            id: i.te_id,
                            selectedSession: selectedSession,
                            selectedgrp: selectedgrp,
                          },
                        });
                      }}
                    >
                      <ChatIcon /> {t("feedback")}
                    </button>
                    <Tooltip
                      title={
                        t("training_summary_planning_tooltip") ||
                        "View heart rate summary; on the next screen, choose a player who recorded heart rate for this exercise."
                      }
                    >
                      <span style={{ display: "inline-flex" }}>
                        <button
                          type="button"
                          className="ex_add_box__action-btn ex_add_box__action-btn--summary"
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate("/Training_Summary", {
                              state: {
                                selectedSession: selectedSession,
                                selectedgrp: selectedgrp,
                                exercise: i,
                              },
                            });
                          }}
                        >
                          <AssessmentOutlinedIcon />{" "}
                          {t("summary") || "Summary"}
                        </button>
                      </span>
                    </Tooltip>
                  </div>
                ) : teStateId === TE_STATE_STARTED ? (
                  <div className="ex_menu_options ex_add_box__actions">
                    <p
                      className="ex_menu_options2"
                      onClick={() =>
                        navigate("/Training_Summary", {
                          state: {
                            id: i.te_id,
                            selectedSession: selectedSession,
                            selectedgrp: selectedgrp,
                            exercise: i,
                          },
                        })
                      }
                    >
                      <FavoriteIcon className="heart" />
                    </p>
                    <p
                      className="ex_menu_options2"
                      onClick={() =>
                        setshowoption({ ...showoption, [index]: true })
                      }
                    >
                      <InfoOutlinedIcon sx={{ color: "#a62d32" }} />
                    </p>
                  </div>
                ) : showoption[index] ? (
                  <div className="ex_menu_options ex_add_box__actions">
                    <>
                      <Tooltip title={t("editExercise") || "Edit Exercise"}>
                        <p
                          onClick={() => {
                            handleOpenEditDialog(i);
                            setshowoption({ ...showoption, [index]: false });
                          }}
                        >
                          <DriveFileRenameOutlineIcon />
                        </p>
                      </Tooltip>
                      <Tooltip title={t("exchangeExercise") || t("changeex")}>
                        <p
                          onClick={() =>
                            navigate("/ChangeExercise", {
                              state: {
                                grpid: resolveSessionGroupId(selectedSession, selectedgrp),
                                exid: i.ex_id,
                                teid: i.te_id,
                                duration: i.te_duration,
                                cbid: i.ex_sub_type_id
                                  ? i.ex_sub_type_id?.cb_id
                                  : "",
                                cb: i.ex_sub_type_id?.[`cb_name_${currentlng}`],
                                subid: i.sub_type_ex?.sub_type_id,
                                subtype:
                                  i.sub_type_ex?.[`sub_type_name_${currentlng}`],
                                id: i.type_ex?.type_id,
                                type: i.type_ex?.[`type_name_${currentlng}`],
                                session: selectedSession,
                              },
                            })
                          }
                        >
                          <LoopIcon />
                        </p>
                      </Tooltip>
                      <Tooltip title="View">
                        <p
                          onClick={() =>
                            navigate("/Exercisedetail", {
                              state: { id: i.te_id },
                            })
                          }
                        >
                          <VisibilityIcon />
                        </p>
                      </Tooltip>
                    </>
                  </div>
                ) : (
                  <div className="ex_add_box__actions">
                    <InfoOutlinedIcon
                      className="exercise_info"
                      onClick={() =>
                        setshowoption({ ...showoption, [index]: true })
                      }
                    />
                  </div>
                )}
                {canShowDeleteButton ? (
                  <Tooltip title={t("delete") || "Delete"}>
                    <button
                      type="button"
                      className="ex_add_box__delete-corner"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleOpenDeleteDialog(i);
                      }}
                    >
                      <DeleteIcon sx={{ fontSize: 18 }} />
                      <span>{t("delete") || "Delete"}</span>
                    </button>
                  </Tooltip>
                ) : null}
                {isKotCard ? (
                  <KingOfTableSettings
                    embedded
                    te_id={i.te_id}
                    ts_id={selectedSession?.ts_id}
                    initialConfig={i.kot_config || null}
                    canEdit={canEditPlanRow && !isRunning}
                    isCoachView={canEditPlanning}
                    viewerPlayerId={viewerPlayerId}
                    canEnterMatchResults={false}
                    canEnterOwnMatchResults={false}
                    readOnlyView={isSessionReadOnly}
                    socket={socket}
                    isActive={isRunning}
                    exerciseStateId={teStateId}
                    teStartTime={i.te_start_time}
                    teEndTime={i.te_end_time}
                    plannedDurationMinutes={i.te_duration}
                    remainingSeconds={exerciseTimer}
                    onSaved={(savedCfg) => {
                      setlist((prev) =>
                        prev.map((ex) =>
                          String(ex.te_id) === String(i.te_id)
                            ? { ...ex, kot_config: savedCfg, is_kot_type: true }
                            : ex
                        )
                      );
                    }}
                  />
                ) : null}
              </div>
              );
            })}
          </div>
          <p className="error_msg">{error}</p>
          <Snackbar
            open={open}
            autoHideDuration={4000}
            onClose={() => {
              setopen(false);
              setTimeout(() => {
                setsuccess("");
                seterror("");
              }, 150);
            }}
          >
            <Alert variant="filled" severity={snackbarSeverity}>
              {snackbarSeverity === "success" ? success : error}
            </Alert>
          </Snackbar>

          <Dialog
            open={deleteDialogOpen}
            onClose={handleCloseDeleteDialog}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleConfirmDelete();
              }
            }}
            maxWidth="xs"
            fullWidth
          >
            <DialogTitle>
              {t("deleteTrainingBlock") || t("deleteExercise") || "Delete training block"}
            </DialogTitle>
            <DialogContent>
              <Typography sx={{ color: "#444", mt: 0.5 }}>
                {t("confirmDeleteTrainingBlock") ||
                  t("confirmDeleteExercise") ||
                  "Are you sure you want to delete this training block from this station?"}
              </Typography>
              {exerciseToDelete ? (
                <Typography sx={{ mt: 1.5, fontWeight: 600 }}>
                  {localizedExerciseName(exerciseToDelete, currentlng) ||
                    exerciseToDelete.ex_name ||
                    t("trainingBlock") ||
                    "Training block"}
                </Typography>
              ) : null}
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseDeleteDialog}>
                {t("cancel") || "Cancel"}
              </Button>
              <Button
                onClick={handleConfirmDelete}
                variant="contained"
                color="error"
                autoFocus
              >
                {t("delete") || "Delete"}
              </Button>
            </DialogActions>
          </Dialog>

          {/* Template Selection Dialog */}
          <SelectSessionTemplateDialog
            open={templateDialogOpen}
            onClose={() => {
              setTemplateDialogOpen(false);
              setSelectedTemplate(null);
            }}
            templates={templates}
            selectedTemplate={selectedTemplate}
            onSelectTemplate={setSelectedTemplate}
            onApply={handleApplyTemplate}
            applying={loadingTemplate}
          />

          <TemplateApplyWizardDialog
            open={templateApplyWizardOpen}
            template={selectedTemplate}
            tsId={selectedSession?.ts_id}
            grId={selectedSession?.gr_id || selectedgrp?.groupDetails?.gr_id}
            teId={list?.[0]?.te_id || selectedExercise?.te_id}
            applying={loadingTemplate}
            onClose={() => setTemplateApplyWizardOpen(false)}
            onBackToSelect={() => {
              setTemplateApplyWizardOpen(false);
              setTemplateDialogOpen(true);
            }}
            onConfirm={({ typesOnly, cbSlotChoices, levelContext }) => {
              const grId = selectedSession.gr_id || selectedgrp?.groupDetails?.gr_id;
              setTemplateApplyWizardOpen(false);
              doApplyTemplate(grId, cbSlotChoices || null, {
                typesOnly: !!typesOnly,
                levelContext: levelContext || null,
              });
            }}
            onError={seterror}
          />

          {/* Goal-based 90-minute session generation dialog */}
          <Dialog
            open={structuredSessionDialogOpen}
            onClose={() => setStructuredSessionDialogOpen(false)}
            maxWidth="xs"
            fullWidth
          >
            <DialogTitle>{t("generateSession") || "Generate Session"}</DialogTitle>
            <DialogContent>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                {t("goalBasedSessionHint") ||
                  "Generate a 90-minute session from group goals: warmup, two competency blocks, a personalized exercise, and montée de table."}
              </Typography>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={includeStretchingAddon}
                    onChange={(e) => setIncludeStretchingAddon(e.target.checked)}
                  />
                }
                label={
                  t("includeStretchingAddon") ||
                  "Add optional 5-minute stretching at the end (95 min total)"
                }
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setStructuredSessionDialogOpen(false)} style={{ color: "#666" }}>
                {t("cancel") || "Cancel"}
              </Button>
              <Button
                variant="contained"
                onClick={handleGenerateStructuredSession}
                disabled={loadingSessionPlan}
              >
                {loadingSessionPlan ? (t("loading") || "Loading...") : (t("generate") || "Generate")}
              </Button>
            </DialogActions>
          </Dialog>

          {/* AI Recommendation Type Choice Dialog */}
          <Dialog
            open={aiRecommendChoiceDialogOpen}
            onClose={() => setAiRecommendChoiceDialogOpen(false)}
            maxWidth="xs"
            fullWidth
          >
            <DialogTitle>{t("aiRecommendations") || "AI Recommendations"}</DialogTitle>
            <DialogContent>
              <p style={{ marginBottom: "16px", color: "#555" }}>
                {t("aiRecommendChoiceQuestion") || "What would you like?"}
              </p>
              <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                <InputLabel>{t("sessionContext") || "Session context"}</InputLabel>
                <Select
                  value={recommendationSessionType}
                  label={t("sessionContext") || "Session context"}
                  onChange={(e) => setRecommendationSessionType(e.target.value)}
                >
                  <MenuItem value="warmup">{t("sessionContextWarmup") || "Échauffement"}</MenuItem>
                  <MenuItem value="main">{t("sessionContextTraining") || "Training"}</MenuItem>
                  <MenuItem value="table_approach">{t("sessionContextTableApproach") || "Montée de table"}</MenuItem>
                  <MenuItem value="recovery">{t("sessionContextStretching") || "Étirements"}</MenuItem>
                </Select>
              </FormControl>
              <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                <Button
                  variant="outlined"
                  fullWidth
                  onClick={handleGetAIRecommendations}
                  style={{ justifyContent: "flex-start", textTransform: "none" }}
                >
                  {t("aiRecommendExercise") || "Exercise recommendation"}
                </Button>
                <Button
                  variant="outlined"
                  fullWidth
                  onClick={handleGetSessionPlanRecommendation}
                  style={{ justifyContent: "flex-start", textTransform: "none" }}
                >
                  {t("aiRecommendWholeSession") || "Whole training session recommendation"}
                </Button>
                <p style={{ fontSize: "0.85em", color: "#888", marginTop: "8px" }}>
                  {t("aiRecommendWholeSessionHint") || "Following the structure of a session template of the same duration."}
                </p>
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setAiRecommendChoiceDialogOpen(false)} style={{ color: "#666" }}>
                {t("cancel") || "Cancel"}
              </Button>
            </DialogActions>
          </Dialog>

          {/* AI Recommendations Dialog */}
          <Dialog
            open={recommendDialogOpen}
            onClose={() => {
              setRecommendDialogOpen(false);
              setRecommendedExercises([]);
              setSelectedRecommendExercise(null);
            }}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle>{t("aiRecommendedExercises") || "AI Recommended Exercises"}</DialogTitle>
            <DialogContent>
              {loadingRecommend ? (
                <div style={{ textAlign: "center", padding: "30px" }}>
                  {t("loading") || "Loading..."}
                </div>
              ) : recommendedExercises.length === 0 && !loadingRecommend ? (
                <div style={{ textAlign: "center", padding: "20px", color: "#666" }}>
                  {t("noRecommendations") || "No exercises recommended for this session. Ensure players have levels and focuses set."}
                </div>
              ) : (
                <div style={{ display: "flex", flexDirection: "column", gap: "12px", marginTop: "10px" }}>
                  {recommendedExercises.map((ex) => (
                    <ExerciseCard
                      key={ex.ex_id}
                      exercise={{ ...ex, duration: ex.duration ?? 10 }}
                      isSelected={selectedRecommendExercise?.ex_id === ex.ex_id}
                      onSelect={() => {
                        setSelectedRecommendExercise(ex);
                        handleSelectRecommendedExercise(ex);
                      }}
                      lng={currentlng}
                      t={t}
                      selectMode="single"
                      showDurationInput={false}
                    />
                  ))}
                </div>
              )}
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  setRecommendDialogOpen(false);
                  setRecommendedExercises([]);
                  setSelectedRecommendExercise(null);
                }}
                style={{ color: "#666" }}
              >
                {t("close") || "Close"}
              </Button>
            </DialogActions>
          </Dialog>

          {/* Generated Session Plan Dialog – wizard: template + choose one of 3 exercises per slot */}
          <Dialog
            open={sessionPlanDialogOpen}
            onClose={() => {
              setSessionPlanDialogOpen(false);
              setGeneratedSessionPlan(null);
              setSessionPlanSlotSelections({});
            }}
            maxWidth="md"
            fullWidth
            PaperProps={{ sx: { borderRadius: "12px", overflow: "hidden" } }}
          >
            <DialogTitle sx={{ borderBottom: "1px solid #eee", pb: 1.5 }}>
              {t("aiRecommendedSessionPlan") || "AI Recommended Session Plan"}
            </DialogTitle>
            <DialogContent sx={{ pt: 2 }}>
              {loadingSessionPlan ? (
                <div style={{ textAlign: "center", padding: "30px" }}>
                  {t("loading") || "Loading..."}
                </div>
              ) : !generatedSessionPlan?.generated_session ? (
                <div style={{ textAlign: "center", padding: "20px", color: "#666" }}>
                  {t("noRecommendations") || "No session plan available."}
                </div>
              ) : (
                <div style={{ display: "flex", flexDirection: "column", gap: "20px", marginTop: "4px" }}>
                  {generatedSessionPlan.selected_template && (
                    <Box
                      sx={{
                        p: 1.5,
                        borderRadius: "10px",
                        background:
                          "linear-gradient(135deg, var(--brand-primary, #0877BC) 0%, var(--brand-primary-dark, #0d47a1) 100%)",
                        color: "#fff",
                        textAlign: "center",
                      }}
                    >
                      <Typography variant="subtitle2" sx={{ opacity: 0.9 }}>
                        {t("templateSelectedForGroup") || "Template selected for your group"}
                      </Typography>
                      <Typography variant="h6" sx={{ fontWeight: 600, mt: 0.5 }}>
                        {generatedSessionPlan.selected_template.tst_name}
                      </Typography>
                    </Box>
                  )}
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                    {generatedSessionPlan.selected_template
                      ? (t("chooseOneExercisePerSlot") || "Choose one exercise per slot below, then apply.")
                      : (t("recommendedPlan") || "Recommended plan for this session.")}
                  </Typography>
                  {generatedSessionPlan.generated_session.items?.map((item, idx) => (
                    <Paper
                      key={idx}
                      variant="outlined"
                      sx={{
                        p: 1.5,
                        borderRadius: "10px",
                        borderColor: "#e0e0e0",
                        borderWidth: 1,
                      }}
                    >
                      <Typography variant="subtitle2" color="primary" sx={{ fontWeight: 600, mb: 1 }}>
                        {(() => {
                          const itemIndex = item.itemIndex !== undefined ? Number(item.itemIndex) : idx;
                          const selId =
                            sessionPlanSlotSelections[itemIndex] ??
                            sessionPlanSlotSelections[idx] ??
                            item.recommended_exercises?.[0]?.ex_id;
                          const sel = item.recommended_exercises?.find((r) => r.ex_id === selId);
                          const mins =
                            parseInt(sel?.duration, 10) ||
                            parseInt(item.duration_minutes, 10) ||
                            10;
                          return `${item.label} · ${mins} min`;
                        })()}
                      </Typography>
                      <div className="expage-grid">
                        {item.recommended_exercises?.slice(0, 3).map((ex, exIdx) => (
                          <ExerciseCard
                            key={ex.ex_id || exIdx}
                            exercise={{ ...ex, duration: ex.duration ?? 10 }}
                            isSelected={(() => {
                              const itemIndex = item.itemIndex !== undefined ? Number(item.itemIndex) : idx;
                              const sel =
                                sessionPlanSlotSelections[itemIndex] ?? sessionPlanSlotSelections[idx];
                              return sel === ex.ex_id;
                            })()}
                            onSelect={() =>
                              setSessionPlanSlotSelections((prev) => {
                                const itemIndex = item.itemIndex !== undefined ? Number(item.itemIndex) : idx;
                                return { ...prev, [itemIndex]: ex.ex_id, [idx]: ex.ex_id };
                              })
                            }
                            lng={currentlng}
                            t={t}
                            selectMode="single"
                            showDurationInput={false}
                            slotCbName={item.cb_name || null}
                          />
                        ))}
                      </div>
                    </Paper>
                  ))}
                </div>
              )}
            </DialogContent>
            <DialogActions sx={{ borderTop: "1px solid #eee", px: 2, py: 1.5 }}>
              <Button
                onClick={() => {
                  setSessionPlanDialogOpen(false);
                  setGeneratedSessionPlan(null);
                  setSessionPlanSlotSelections({});
                }}
                style={{ color: "#666" }}
              >
                {t("close") || "Close"}
              </Button>
              {generatedSessionPlan?.generated_session?.items?.some((i) => i.recommended_exercises?.length > 0) && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleApplySessionPlan}
                  disabled={loadingSessionPlan || (generatedSessionPlan?.selected_template && Object.keys(sessionPlanSlotSelections).length === 0)}
                >
                  {loadingSessionPlan ? (t("applying") || "Applying...") : (t("applySessionPlan") || "Apply Session Plan")}
                </Button>
              )}
            </DialogActions>
          </Dialog>

          {/* Edit Exercise Dialog */}
          <Dialog
            open={editDialogOpen}
            onClose={handleCloseEditDialog}
            fullScreen={isEditDialogMobile}
            maxWidth="md"
            fullWidth
            scroll="paper"
            className={editDialogThemeClass}
            PaperProps={{ className: `eed-dialog ${editDialogThemeClass}` }}
          >
            <div className="eed-header">
              <div className="eed-header__text">
                <p className="eed-header__eyebrow">{t("planning") || "Planning"}</p>
                <h2 className="eed-header__title">
                  {isTypeOnlyBlock(editingExercise)
                    ? t("editExerciseType") || "Edit type"
                    : t("editExercise") || "Edit Exercise"}
                </h2>
                {editingExercise?.te_execution_type ? (
                  <span className="eed-header__mode">
                    {editingExercise.te_execution_type === "TE_SEQUENCES"
                      ? t("modeSequences") || "Sequences"
                      : editingExercise.te_execution_type === "TE_ONCE"
                        ? t("modeOnce") || "Single timer"
                        : editingExercise.te_execution_type === "TE_ROUNDS"
                          ? t("modeRounds") || "King of the Table"
                          : editingExercise.te_execution_type}
                  </span>
                ) : null}
              </div>
              <IconButton
                onClick={handleCloseEditDialog}
                aria-label={t("close") || "Close"}
                size="small"
              >
                <CloseIcon />
              </IconButton>
            </div>

            <div className="eed-body">
              {editingExercise ? (
                <div className="eed-hero">
                  <div className="eed-hero__top">
                    {editingExercise?.sub_type_ex?.sub_type_image_normal ? (
                      <div className="eed-hero__img">
                        <img
                          src={ip_back + editingExercise.sub_type_ex.sub_type_image_normal}
                          alt=""
                        />
                      </div>
                    ) : null}
                    <div className="eed-hero__info">
                      <h3 className="eed-hero__name">
                        {localizedExerciseName(editingExercise, currentlng) ||
                          blockTypeHeadline(editingExercise, currentlng) ||
                          exchangeFilterMeta.label ||
                          t("trainingBlock") ||
                          "Training block"}
                      </h3>
                      <div className="eed-hero__tags">
                        {localizedTypeName(
                          exerciseTypes.find(
                            (row) => String(row.type_id) === String(selectedTypeId)
                          ) || editingExercise.type_ex,
                          currentlng
                        ) ? (
                          <span className="eed-tag eed-tag--type">
                            {localizedTypeName(
                              exerciseTypes.find(
                                (row) =>
                                  String(row.type_id) === String(selectedTypeId)
                              ) || editingExercise.type_ex,
                              currentlng
                            )}
                          </span>
                        ) : null}
                        {exchangeFilterMeta.label ? (
                          <span className="eed-tag eed-tag--subtype">
                            {exchangeFilterMeta.label}
                          </span>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  <button
                    type="button"
                    className="eed-exchange-btn"
                    onClick={() => setExchangeDialogOpen(true)}
                    disabled={false}
                  >
                    <SwapHorizIcon sx={{ fontSize: 20 }} />
                    {isTypeOnlyBlock(editingExercise)
                      ? t("assignExercise") || "Assign exercise"
                      : t("exchangeExercise") || "Exchange exercise"}
                  </button>
                </div>
              ) : null}

              <div className="eed-section">
                <h4 className="eed-section__title">{t("duration") || "Duration"}</h4>
                <div className="eed-section__row eed-section__row--duration">
                  <DurationMinutesSecondsInput
                    value={editDuration}
                    onChange={handleDurationChange}
                  />
                  {!editDuration && lastValidDuration ? (
                    <span className="eed-seq__duration-hint">
                      {t("keepingLastValue") || "Keeping last valid value"}
                    </span>
                  ) : null}
                </div>
              </div>

              {isOffTableExercise(editingExercise) ||
              isOffTableExerciseType(
                exerciseTypes.find((row) => row.type_id === selectedTypeId)
              ) ? (
                <div className="eed-section">
                  <h4 className="eed-section__title">
                    {t("planningOffTableTools") || "Live Training tools"}
                  </h4>
                  <OffTableCoachToolsEditor
                    value={editCoachTools}
                    onChange={setEditCoachTools}
                  />
                </div>
              ) : null}

              {editingExercise ? (
                <div className="eed-section">
                  <h4 className="eed-section__title">
                    {t("exerciseType") || "Exercise type"}
                  </h4>
                  <div className="eed-section__row">
                    <FormControl fullWidth size="small">
                      <InputLabel>{t("exerciseType") || "Exercise Type"}</InputLabel>
                      <Select
                        value={selectedTypeId || ""}
                        label={t("exerciseType") || "Exercise Type"}
                        onChange={(e) => handleEditTypeChange(e.target.value)}
                        MenuProps={{
                          PaperProps: { sx: { maxHeight: "min(400px, 70vh)" } },
                          disableScrollLock: true,
                        }}
                      >
                        {exerciseTypes && exerciseTypes.length > 0 ? (
                          exerciseTypes.map((type) => (
                            <MenuItem key={type.type_id} value={type.type_id}>
                              {localizedTypeName(type, currentlng) || type.type_name_en}
                            </MenuItem>
                          ))
                        ) : (
                          <MenuItem disabled>
                            {t("loadingTypes") || t("loading") || "Loading types..."}
                          </MenuItem>
                        )}
                      </Select>
                    </FormControl>

                    {selectedTypeId &&
                      isCompetencyBlockExerciseType(
                        exerciseTypes.find((row) => row.type_id === selectedTypeId)
                      ) && (
                        <FormControl fullWidth size="small">
                          <InputLabel>
                            {t("trainingBlock") || "Training block"}
                          </InputLabel>
                          <Select
                            value={nestedId(selectedSubTypeId, ["cb_id", "sub_type_id"]) || ""}
                            label={t("trainingBlock") || "Training block"}
                            onChange={(e) => handleTrainingBlockKindChange(e.target.value)}
                            MenuProps={{
                              PaperProps: { sx: { maxHeight: "min(400px, 70vh)" } },
                              disableScrollLock: true,
                            }}
                          >
                            {competencyBlocks.length > 0 ? (
                              competencyBlocks.map((block) => {
                                const blockIcon = competencyBlockIconSrc(block);
                                const blockLabel =
                                  localizedCbName(block, currentlng.split("-")[0]) ||
                                  block.cb_name_en ||
                                  block.name;
                                return (
                                <MenuItem key={block.cb_id} value={block.cb_id}>
                                  {blockIcon ? (
                                    <img
                                      src={blockIcon}
                                      alt=""
                                      style={{
                                        width: 48,
                                        height: 48,
                                        borderRadius: 12,
                                        objectFit: "contain",
                                        marginRight: 10,
                                        padding: 3,
                                        boxSizing: "border-box",
                                        background:
                                          "color-mix(in srgb, var(--brand-primary-light, var(--brand-primary, #0877bc)) 18%, #ffffff)",
                                        border:
                                          "1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent)",
                                      }}
                                    />
                                  ) : null}
                                  {blockLabel}
                                </MenuItem>
                                );
                              })
                            ) : (
                              <MenuItem disabled>
                                {t("loading") || "Loading..."}
                              </MenuItem>
                            )}
                          </Select>
                        </FormControl>
                      )}

                    {selectedTypeId &&
                      !isCompetencyBlockExerciseType(
                        exerciseTypes.find((row) => row.type_id === selectedTypeId)
                      ) &&
                      !isSubtypeFreeType(
                        exerciseTypes.find((row) => row.type_id === selectedTypeId)
                      ) && (
                        <FormControl fullWidth size="small" disabled={!selectedTypeId}>
                          <InputLabel>
                            {t("exerciseSubtype") || "Exercise Subtype"}
                          </InputLabel>
                          <Select
                            value={
                              typeof selectedSubTypeId === "object"
                                ? selectedSubTypeId?.sub_type_id || ""
                                : selectedSubTypeId || ""
                            }
                            label={t("exerciseSubtype") || "Exercise Subtype"}
                            onChange={(e) => handleTrainingBlockKindChange(e.target.value)}
                            MenuProps={{
                              PaperProps: { sx: { maxHeight: "min(400px, 70vh)" } },
                              disableScrollLock: true,
                            }}
                          >
                            {exerciseSubTypes && exerciseSubTypes.length > 0 ? (
                              exerciseSubTypes.map((subType) => (
                                <MenuItem
                                  key={subType.sub_type_id}
                                  value={subType.sub_type_id}
                                >
                                  {subType[`sub_type_name_${currentlng}`] ||
                                    subType.sub_type_name_en}
                                </MenuItem>
                              ))
                            ) : (
                              <MenuItem disabled>
                                {selectedTypeId
                                  ? t("loadingSubtypes") || t("loading") || "Loading subtypes..."
                                  : t("selectTypeFirst") || "Select a type first"}
                              </MenuItem>
                            )}
                          </Select>
                        </FormControl>
                      )}
                  </div>

                  {selectedSubTypeId &&
                    sessionExercisesGroupedForSelectedSubtype.length > 0 && (
                      <div className="eed-same-skill">
                        <span className="eed-same-skill__label">
                          {t("sameSkillInThisSession") ||
                            "In this session — same skill / block name"}
                        </span>
                        {sessionExercisesGroupedForSelectedSubtype.map(
                          ({ typeLabel, rows }) => (
                            <div key={typeLabel} className="eed-same-skill__group">
                              <p className="eed-same-skill__type">{typeLabel}</p>
                              <ul className="eed-same-skill__list">
                                {rows.map((row) => (
                                  <li key={String(row.te_id)}>
                                    #{row.te_order} — {row.title}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )
                        )}
                      </div>
                    )}
                </div>
              ) : null}

                {/* Sequences: editable for all non-KOT exercises */}
                {editingExercise && !isKotExercise(editingExercise) && (
                  <div className="eed-section">
                    <div className="eed-seq-head">
                      <h4 className="eed-seq-head__title">
                        {t("sequences") || "Sequences"}
                      </h4>
                      <span
                        className={`eed-seq-head__remain${
                          calculateRemainingTime() < 0
                            ? " eed-seq-head__remain--over"
                            : calculateRemainingTime() === 0
                              ? " eed-seq-head__remain--ok"
                              : ""
                        }`}
                      >
                        {t("remainingTime") || "Remaining"}: {calculateRemainingTime()}{" "}
                        {t("min") || "min"}
                      </span>
                    </div>
                    <div className="eed-seq-presets">
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => applySequenceLayout("role_swap")}
                      >
                        {t("sequenceLayoutRoleSwap") || "Switch roles (2)"}
                      </Button>
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() => applySequenceLayout("together")}
                      >
                        {t("sequenceLayoutTogether") || "Both play (1)"}
                      </Button>
                      <Button size="small" variant="contained" onClick={handleAddSequence}>
                        {t("addSequence") || "Add sequence"}
                      </Button>
                    </div>
                    {editSequences.length === 0 ? (
                      <p className="eed-seq-empty">
                        {t("noSequencesYet") ||
                          "No sequences yet. Add one, or use a layout preset above."}
                      </p>
                    ) : null}
                    {editSequences
                      .sort((a, b) => {
                        const orderA = a.sequence_order || 0;
                        const orderB = b.sequence_order || 0;
                        return orderA - orderB;
                      })
                      .map((seq, seqIdx) => {
                      const seqTypeRow = exerciseTypes.find((row) => row.type_id === selectedTypeId);
                      const seqIsCb = isCompetencyBlockExerciseType(seqTypeRow);
                      const currentKindId = seq.sub_type_id || seq.lastValidSubTypeId;
                      const currentSubType = seqIsCb
                        ? competencyBlocks.find((block) => String(block.cb_id) === String(currentKindId))
                        : exerciseSubTypes.find((st) => st.sub_type_id === currentKindId);
                      const isDragged = draggedSequenceIndex === seq.tes_id;
                      const isDragOver = dragOverSequenceIndex === seq.tes_id;
                      // Use sequence_order from editSequences (updated after drag) instead of originalSeq
                      const sequenceOrder = seq.sequence_order || seqIdx + 1;
                      
                      return (
                        <div 
                          key={seq.tes_id || seqIdx} 
                          className={`eed-seq${isDragged ? " eed-seq--dragging" : ""}${
                            isDragOver ? " eed-seq--over" : ""
                          }${
                            isDragging && !isDragged && draggedSequenceIndex != null
                              ? " eed-seq--dimmed"
                              : ""
                          }`}
                          draggable={true}
                          onDragStart={(e) => {
                            e.dataTransfer.effectAllowed = "move";
                            handleSequenceDragStart(seq.tes_id, seqIdx, e);
                          }}
                          onDragEnd={handleSequenceDragEnd}
                          onDragOver={(e) => {
                            e.preventDefault();
                            e.dataTransfer.dropEffect = "move";
                            handleSequenceDragOver(seq.tes_id, e);
                          }}
                          onTouchStart={(e) => {
                            // Only start drag if touching the drag handle or sequence header
                            const target = e.target;
                            const isDragHandle = target.closest('[data-drag-handle]') || 
                                               target.closest('.MuiSvgIcon-root') ||
                                               target.closest('[role="button"]');
                            if (isDragHandle || e.currentTarget === e.target) {
                              handleSequenceDragStart(seq.tes_id, seqIdx, e);
                            }
                          }}
                          onTouchMove={(e) => {
                            if (isDragging) {
                              e.preventDefault();
                              // Find which sequence we're over
                              const touch = e.touches[0];
                              const elementBelow = document.elementFromPoint(touch.clientX, touch.clientY);
                              const sequenceBox = elementBelow?.closest('[data-sequence-box]');
                              if (sequenceBox) {
                                const tesId = sequenceBox.getAttribute('data-tes-id');
                                // Convert to string for consistent comparison
                                const tesIdStr = String(tesId);
                                const draggedIdStr = String(draggedSequenceIndex);
                                if (tesId && tesIdStr !== draggedIdStr) {
                                  setDragOverSequenceIndex(tesId);
                                }
                              }
                            } else {
                              // Only prevent default if we're in the press-hold phase and user moves significantly
                              // Otherwise allow normal scrolling
                              handleSequenceTouchMove(e);
                            }
                          }}
                          onTouchEnd={handleSequenceTouchEnd}
                          data-sequence-box="true"
                          data-tes-id={String(seq.tes_id)}
                          onMouseDown={(e) => {
                            // Prevent drag on form inputs
                            if (e.target.tagName === 'INPUT' || e.target.tagName === 'SELECT' || e.target.closest('.MuiFormControl-root')) {
                              return;
                            }
                          }}
                        >
                          <div className="eed-seq__header">
                            <DragIndicatorIcon
                              data-drag-handle="true"
                              sx={{
                                color: "var(--brand-primary, #0877BC)",
                                cursor: "grab",
                                touchAction: isDragging ? "none" : "pan-y",
                                fontSize: "20px",
                                opacity: isDragging ? 0.7 : 1,
                                "&:active": {
                                  cursor: "grabbing",
                                },
                              }}
                              onMouseDown={(e) => {
                                e.stopPropagation();
                                if (!isDragging) {
                                  setIsDragging(true);
                                  setDraggedSequenceIndex(seq.tes_id);
                                }
                              }}
                              onTouchStart={(e) => {
                                e.stopPropagation();
                                handleSequenceDragStart(seq.tes_id, seqIdx, e);
                              }}
                            />
                            <span className="eed-seq__num">{sequenceOrder}</span>
                            <span className="eed-seq__label">
                              {currentSubType
                                ? seqIsCb
                                  ? localizedCbName(currentSubType, currentlng.split("-")[0]) ||
                                    currentSubType.cb_name_en ||
                                    ""
                                  : currentSubType[`sub_type_name_${currentlng}`] ||
                                    currentSubType.sub_type_name_en ||
                                    ""
                                : `${t("sequence") || "Sequence"} ${sequenceOrder}`}
                            </span>
                            {editSequences.length > 1 && (
                              <Tooltip title={t("deleteSequence") || "Remove sequence"}>
                                <span>
                                  <IconButton
                                    size="small"
                                    aria-label={t("deleteSequence") || "Remove sequence"}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleDeleteSequence(seq.tes_id, seqIdx);
                                    }}
                                    sx={{ color: "error.main" }}
                                  >
                                    <DeleteIcon fontSize="small" />
                                  </IconButton>
                                </span>
                              </Tooltip>
                            )}
                          </div>

                          <div className="eed-seq__fields">
                          {/* Subtype Selection - scrollable list so all subtypes visible on mobile */}
                          <FormControl fullWidth size="small">
                            <InputLabel>
                              {seqIsCb
                                ? t("trainingBlock") || "Training block"
                                : t("exerciseSubtype") || "Exercise Subtype"}
                            </InputLabel>
                            <Select
                              value={seq.sub_type_id || seq.lastValidSubTypeId || ""}
                              label={
                                seqIsCb
                                  ? t("trainingBlock") || "Training block"
                                  : t("exerciseSubtype") || "Exercise Subtype"
                              }
                              onChange={(e) => handleSequenceSubTypeChange(seqIdx, e.target.value)}
                              MenuProps={{
                                PaperProps: { sx: { maxHeight: "min(400px, 70vh)" } },
                                disableScrollLock: true,
                              }}
                            >
                              {seqIsCb
                                ? competencyBlocks.map((block) => (
                                    <MenuItem key={block.cb_id} value={block.cb_id}>
                                      {localizedCbName(block, currentlng.split("-")[0]) ||
                                        block.cb_name_en ||
                                        block.name}
                                    </MenuItem>
                                  ))
                                : exerciseSubTypes.map((subType) => (
                                    <MenuItem key={subType.sub_type_id} value={subType.sub_type_id}>
                                      {subType[`sub_type_name_${currentlng}`] || subType.sub_type_name_en}
                                    </MenuItem>
                                  ))}
                            </Select>
                          </FormControl>
                          
                          {/* Duration Input */}
                          <div className="eed-seq__duration">
                            <span className="eed-seq__duration-label">
                              {t("sequenceDuration") || "Sequence duration"}
                            </span>
                            <DurationMinutesSecondsInput
                              value={seq.sequence_duration}
                              onChange={(next) =>
                                handleSequenceDurationChange(seqIdx, next)
                              }
                            />
                            {!seq.sequence_duration && seq.lastValidDuration ? (
                              <span className="eed-seq__duration-hint">
                                {t("keepingLastValue") || "Keeping last valid value"}
                              </span>
                            ) : null}
                          </div>
                          
                          {/* Player Roles - Editable */}
                          <div className="eed-seq__roles">
                            <FormControl size="small" fullWidth>
                              <InputLabel>{t("playerA") || "Player A Role"}</InputLabel>
                              <Select
                                value={seq.player_a_role || "active"}
                                label={t("playerA") || "Player A Role"}
                                onChange={(e) => handleSequenceRoleChange(seqIdx, "player_a_role", e.target.value)}
                              >
                                <MenuItem value="active">{t("performance_role", "Performance")}</MenuItem>
                                <MenuItem value="sparring">{t("sparring") || "Sparring"}</MenuItem>
                                <MenuItem value="both">{t("both") || "Both"}</MenuItem>
                              </Select>
                            </FormControl>
                            <FormControl size="small" fullWidth>
                              <InputLabel>{t("playerB") || "Player B Role"}</InputLabel>
                              <Select
                                value={seq.player_b_role || "sparring"}
                                label={t("playerB") || "Player B Role"}
                                onChange={(e) => handleSequenceRoleChange(seqIdx, "player_b_role", e.target.value)}
                              >
                                <MenuItem value="active">{t("performance_role", "Performance")}</MenuItem>
                                <MenuItem value="sparring">{t("sparring") || "Sparring"}</MenuItem>
                                <MenuItem value="both">{t("both") || "Both"}</MenuItem>
                              </Select>
                            </FormControl>
                          </div>

                          {/* Per-sequence Player A / Player B selectors (TE_SEQUENCES mode).
                              Options are sourced from the exercise's tbl_te_player roster.
                              Stored on sequence.player_a_id / player_b_id and forwarded
                              by handleSaveEdit so the sequence stays the source of truth. */}
                          {(editingExercise?.players || []).length > 0 && (
                            <div className="eed-seq__roles">
                              <FormControl size="small" fullWidth>
                                <InputLabel>{t("playerAName") || "Player A"}</InputLabel>
                                <Select
                                  value={seq.player_a_id || ""}
                                  label={t("playerAName") || "Player A"}
                                  onChange={(e) =>
                                    setEditSequences((prev) =>
                                      prev.map((s, i) =>
                                        i === seqIdx
                                          ? { ...s, player_a_id: e.target.value || null }
                                          : s
                                      )
                                    )
                                  }
                                >
                                  <MenuItem value="">
                                    <em>{t("unassigned") || "Unassigned"}</em>
                                  </MenuItem>
                                  {(editingExercise?.players || []).map((p) => (
                                    <MenuItem key={`pa-${p.player_id}`} value={p.player_id}>
                                      {p.player_name || p.player_id}
                                      {p.player_position ? ` (${p.player_position})` : ""}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                              <FormControl size="small" fullWidth>
                                <InputLabel>{t("playerBName") || "Player B"}</InputLabel>
                                <Select
                                  value={seq.player_b_id || ""}
                                  label={t("playerBName") || "Player B"}
                                  onChange={(e) =>
                                    setEditSequences((prev) =>
                                      prev.map((s, i) =>
                                        i === seqIdx
                                          ? { ...s, player_b_id: e.target.value || null }
                                          : s
                                      )
                                    )
                                  }
                                >
                                  <MenuItem value="">
                                    <em>{t("unassigned") || "Unassigned"}</em>
                                  </MenuItem>
                                  {(editingExercise?.players || []).map((p) => (
                                    <MenuItem key={`pb-${p.player_id}`} value={p.player_id}>
                                      {p.player_name || p.player_id}
                                      {p.player_position ? ` (${p.player_position})` : ""}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </div>
                          )}
                          {isSoloCapableSequenceExercise(editingExercise) && (
                            <Typography
                              variant="caption"
                              color="text.secondary"
                              sx={{ display: "block" }}
                            >
                              {t(
                                "service_player_b_optional",
                                "Player B is optional for service drills (basket of balls)."
                              )}
                            </Typography>
                          )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
            </div>
            <div className="eed-footer">
              <Button
                className="eed-footer__btn"
                onClick={handleCloseEditDialog}
                variant="outlined"
              >
                {t("cancel") || "Cancel"}
              </Button>
              <Button
                className="eed-footer__btn eed-footer__btn--primary"
                onClick={handleSaveEdit}
                variant="contained"
                disabled={!editDuration && !lastValidDuration}
              >
                {t("save") || "Save"}
              </Button>
            </div>
          </Dialog>

          <ExchangeExerciseDialog
            open={exchangeDialogOpen}
            onClose={() => !exchangingExercise && setExchangeDialogOpen(false)}
            onSelect={handleExchangeExercise}
            typeId={exchangeFilterMeta.typeId}
            subTypeId={exchangeFilterMeta.subTypeId}
            cbId={exchangeFilterMeta.cbId}
            groupId={resolveSessionGroupId(selectedSession, selectedgrp)}
            currentExId={editingExercise?.ex_id}
            filterLabel={exchangeFilterMeta.label}
            busy={exchangingExercise}
            initialQuery={exchangeInitialQuery}
          />

        <SplitSubgroupDialog
          open={splitDialogOpen}
          onClose={() => setSplitDialogOpen(false)}
          onCreate={handleCreateSubgroup}
          tables={roomTables}
          existingCount={Math.max(1, subgroups.filter((s) => !s.is_main).length + 1)}
          busy={splitBusy}
        />
        </>
      ) : (
        <p className="select_msg"> {t("please_select_session")}</p>
      )}
    </>
  );
});

Exercises.displayName = "Exercises";
